import type { GraphQLClient, RequestOptions } from 'graphql-request'
import gql from 'graphql-tag'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders']
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  BigFloat: { input: any; output: any }
  BigInt: { input: string; output: string }
  Cursor: { input: any; output: any }
  Date: { input: string; output: string }
  Datetime: { input: any; output: any }
  JSON: { input: Record<string, any>; output: Record<string, any> }
  Opaque: { input: any; output: any }
  Time: { input: string; output: string }
  UUID: { input: string; output: string }
}

/** Boolean expression comparing fields on type "BigFloat" */
export type BigFloatFilter = {
  eq?: InputMaybe<Scalars['BigFloat']['input']>
  gt?: InputMaybe<Scalars['BigFloat']['input']>
  gte?: InputMaybe<Scalars['BigFloat']['input']>
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>
  is?: InputMaybe<FilterIs>
  lt?: InputMaybe<Scalars['BigFloat']['input']>
  lte?: InputMaybe<Scalars['BigFloat']['input']>
  neq?: InputMaybe<Scalars['BigFloat']['input']>
}

/** Boolean expression comparing fields on type "BigFloatList" */
export type BigFloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars['BigFloat']['input']>>
  contains?: InputMaybe<Array<Scalars['BigFloat']['input']>>
  eq?: InputMaybe<Array<Scalars['BigFloat']['input']>>
  is?: InputMaybe<FilterIs>
  overlaps?: InputMaybe<Array<Scalars['BigFloat']['input']>>
}

/** Boolean expression comparing fields on type "BigInt" */
export type BigIntFilter = {
  eq?: InputMaybe<Scalars['BigInt']['input']>
  gt?: InputMaybe<Scalars['BigInt']['input']>
  gte?: InputMaybe<Scalars['BigInt']['input']>
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  is?: InputMaybe<FilterIs>
  lt?: InputMaybe<Scalars['BigInt']['input']>
  lte?: InputMaybe<Scalars['BigInt']['input']>
  neq?: InputMaybe<Scalars['BigInt']['input']>
}

/** Boolean expression comparing fields on type "BigIntList" */
export type BigIntListFilter = {
  containedBy?: InputMaybe<Array<Scalars['BigInt']['input']>>
  contains?: InputMaybe<Array<Scalars['BigInt']['input']>>
  eq?: InputMaybe<Array<Scalars['BigInt']['input']>>
  is?: InputMaybe<FilterIs>
  overlaps?: InputMaybe<Array<Scalars['BigInt']['input']>>
}

/** Boolean expression comparing fields on type "Boolean" */
export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']['input']>
  is?: InputMaybe<FilterIs>
}

/** Boolean expression comparing fields on type "BooleanList" */
export type BooleanListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Boolean']['input']>>
  contains?: InputMaybe<Array<Scalars['Boolean']['input']>>
  eq?: InputMaybe<Array<Scalars['Boolean']['input']>>
  is?: InputMaybe<FilterIs>
  overlaps?: InputMaybe<Array<Scalars['Boolean']['input']>>
}

/** Boolean expression comparing fields on type "Date" */
export type DateFilter = {
  eq?: InputMaybe<Scalars['Date']['input']>
  gt?: InputMaybe<Scalars['Date']['input']>
  gte?: InputMaybe<Scalars['Date']['input']>
  in?: InputMaybe<Array<Scalars['Date']['input']>>
  is?: InputMaybe<FilterIs>
  lt?: InputMaybe<Scalars['Date']['input']>
  lte?: InputMaybe<Scalars['Date']['input']>
  neq?: InputMaybe<Scalars['Date']['input']>
}

/** Boolean expression comparing fields on type "DateList" */
export type DateListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Date']['input']>>
  contains?: InputMaybe<Array<Scalars['Date']['input']>>
  eq?: InputMaybe<Array<Scalars['Date']['input']>>
  is?: InputMaybe<FilterIs>
  overlaps?: InputMaybe<Array<Scalars['Date']['input']>>
}

/** Boolean expression comparing fields on type "Datetime" */
export type DatetimeFilter = {
  eq?: InputMaybe<Scalars['Datetime']['input']>
  gt?: InputMaybe<Scalars['Datetime']['input']>
  gte?: InputMaybe<Scalars['Datetime']['input']>
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>
  is?: InputMaybe<FilterIs>
  lt?: InputMaybe<Scalars['Datetime']['input']>
  lte?: InputMaybe<Scalars['Datetime']['input']>
  neq?: InputMaybe<Scalars['Datetime']['input']>
}

/** Boolean expression comparing fields on type "DatetimeList" */
export type DatetimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Datetime']['input']>>
  contains?: InputMaybe<Array<Scalars['Datetime']['input']>>
  eq?: InputMaybe<Array<Scalars['Datetime']['input']>>
  is?: InputMaybe<FilterIs>
  overlaps?: InputMaybe<Array<Scalars['Datetime']['input']>>
}

export const FilterIs = {
  NotNull: 'NOT_NULL',
  Null: 'NULL'
} as const

export type FilterIs = (typeof FilterIs)[keyof typeof FilterIs]
/** Boolean expression comparing fields on type "Float" */
export type FloatFilter = {
  eq?: InputMaybe<Scalars['Float']['input']>
  gt?: InputMaybe<Scalars['Float']['input']>
  gte?: InputMaybe<Scalars['Float']['input']>
  in?: InputMaybe<Array<Scalars['Float']['input']>>
  is?: InputMaybe<FilterIs>
  lt?: InputMaybe<Scalars['Float']['input']>
  lte?: InputMaybe<Scalars['Float']['input']>
  neq?: InputMaybe<Scalars['Float']['input']>
}

/** Boolean expression comparing fields on type "FloatList" */
export type FloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Float']['input']>>
  contains?: InputMaybe<Array<Scalars['Float']['input']>>
  eq?: InputMaybe<Array<Scalars['Float']['input']>>
  is?: InputMaybe<FilterIs>
  overlaps?: InputMaybe<Array<Scalars['Float']['input']>>
}

/** Boolean expression comparing fields on type "ID" */
export type IdFilter = {
  eq?: InputMaybe<Scalars['ID']['input']>
}

/** Boolean expression comparing fields on type "Int" */
export type IntFilter = {
  eq?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<Scalars['Int']['input']>>
  is?: InputMaybe<FilterIs>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
  neq?: InputMaybe<Scalars['Int']['input']>
}

/** Boolean expression comparing fields on type "IntList" */
export type IntListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Int']['input']>>
  contains?: InputMaybe<Array<Scalars['Int']['input']>>
  eq?: InputMaybe<Array<Scalars['Int']['input']>>
  is?: InputMaybe<FilterIs>
  overlaps?: InputMaybe<Array<Scalars['Int']['input']>>
}

/** The root type for creating and mutating data */
export type Mutation = {
  __typename?: 'Mutation'
  /** Deletes zero or more records from the `balance_snapshot` collection */
  deleteFrombalance_snapshotCollection: Balance_SnapshotDeleteResponse
  /** Deletes zero or more records from the `bot_agent` collection */
  deleteFrombot_agentCollection: Bot_AgentDeleteResponse
  /** Deletes zero or more records from the `bot_command` collection */
  deleteFrombot_commandCollection: Bot_CommandDeleteResponse
  /** Deletes zero or more records from the `candle` collection */
  deleteFromcandleCollection: CandleDeleteResponse
  /** Deletes zero or more records from the `emotion` collection */
  deleteFromemotionCollection: EmotionDeleteResponse
  /** Deletes zero or more records from the `market` collection */
  deleteFrommarketCollection: MarketDeleteResponse
  /** Deletes zero or more records from the `position` collection */
  deleteFrompositionCollection: PositionDeleteResponse
  /** Deletes zero or more records from the `profile_category` collection */
  deleteFromprofile_categoryCollection: Profile_CategoryDeleteResponse
  /** Deletes zero or more records from the `profile_detail` collection */
  deleteFromprofile_detailCollection: Profile_DetailDeleteResponse
  /** Deletes zero or more records from the `psych_event` collection */
  deleteFrompsych_eventCollection: Psych_EventDeleteResponse
  /** Deletes zero or more records from the `research` collection */
  deleteFromresearchCollection: ResearchDeleteResponse
  /** Deletes zero or more records from the `research_report` collection */
  deleteFromresearch_reportCollection: Research_ReportDeleteResponse
  /** Deletes zero or more records from the `scrape_target` collection */
  deleteFromscrape_targetCollection: Scrape_TargetDeleteResponse
  /** Deletes zero or more records from the `scrape_tweet` collection */
  deleteFromscrape_tweetCollection: Scrape_TweetDeleteResponse
  /** Deletes zero or more records from the `scrape_video` collection */
  deleteFromscrape_videoCollection: Scrape_VideoDeleteResponse
  /** Deletes zero or more records from the `scrape_web` collection */
  deleteFromscrape_webCollection: Scrape_WebDeleteResponse
  /** Deletes zero or more records from the `settings` collection */
  deleteFromsettingsCollection: SettingsDeleteResponse
  /** Deletes zero or more records from the `slack_message` collection */
  deleteFromslack_messageCollection: Slack_MessageDeleteResponse
  /** Deletes zero or more records from the `slack_message_user` collection */
  deleteFromslack_message_userCollection: Slack_Message_UserDeleteResponse
  /** Deletes zero or more records from the `strategy` collection */
  deleteFromstrategyCollection: StrategyDeleteResponse
  /** Deletes zero or more records from the `strategy_performance` collection */
  deleteFromstrategy_performanceCollection: Strategy_PerformanceDeleteResponse
  /** Deletes zero or more records from the `timeframe` collection */
  deleteFromtimeframeCollection: TimeframeDeleteResponse
  /** Deletes zero or more records from the `tv_alert` collection */
  deleteFromtv_alertCollection: Tv_AlertDeleteResponse
  /** Deletes zero or more records from the `user` collection */
  deleteFromuserCollection: UserDeleteResponse
  /** Deletes zero or more records from the `user_bot_agent` collection */
  deleteFromuser_bot_agentCollection: User_Bot_AgentDeleteResponse
  /** Deletes zero or more records from the `user_bot_conversation` collection */
  deleteFromuser_bot_conversationCollection: User_Bot_ConversationDeleteResponse
  /** Deletes zero or more records from the `user_profile_category` collection */
  deleteFromuser_profile_categoryCollection: User_Profile_CategoryDeleteResponse
  /** Deletes zero or more records from the `user_profile_detail` collection */
  deleteFromuser_profile_detailCollection: User_Profile_DetailDeleteResponse
  /** Deletes zero or more records from the `user_psych_event` collection */
  deleteFromuser_psych_eventCollection: User_Psych_EventDeleteResponse
  /** Deletes zero or more records from the `user_watching` collection */
  deleteFromuser_watchingCollection: User_WatchingDeleteResponse
  /** Adds one or more `balance_snapshot` records to the collection */
  insertIntobalance_snapshotCollection?: Maybe<Balance_SnapshotInsertResponse>
  /** Adds one or more `bot_agent` records to the collection */
  insertIntobot_agentCollection?: Maybe<Bot_AgentInsertResponse>
  /** Adds one or more `bot_command` records to the collection */
  insertIntobot_commandCollection?: Maybe<Bot_CommandInsertResponse>
  /** Adds one or more `candle` records to the collection */
  insertIntocandleCollection?: Maybe<CandleInsertResponse>
  /** Adds one or more `emotion` records to the collection */
  insertIntoemotionCollection?: Maybe<EmotionInsertResponse>
  /** Adds one or more `market` records to the collection */
  insertIntomarketCollection?: Maybe<MarketInsertResponse>
  /** Adds one or more `position` records to the collection */
  insertIntopositionCollection?: Maybe<PositionInsertResponse>
  /** Adds one or more `profile_category` records to the collection */
  insertIntoprofile_categoryCollection?: Maybe<Profile_CategoryInsertResponse>
  /** Adds one or more `profile_detail` records to the collection */
  insertIntoprofile_detailCollection?: Maybe<Profile_DetailInsertResponse>
  /** Adds one or more `psych_event` records to the collection */
  insertIntopsych_eventCollection?: Maybe<Psych_EventInsertResponse>
  /** Adds one or more `research` records to the collection */
  insertIntoresearchCollection?: Maybe<ResearchInsertResponse>
  /** Adds one or more `research_report` records to the collection */
  insertIntoresearch_reportCollection?: Maybe<Research_ReportInsertResponse>
  /** Adds one or more `scrape_target` records to the collection */
  insertIntoscrape_targetCollection?: Maybe<Scrape_TargetInsertResponse>
  /** Adds one or more `scrape_tweet` records to the collection */
  insertIntoscrape_tweetCollection?: Maybe<Scrape_TweetInsertResponse>
  /** Adds one or more `scrape_video` records to the collection */
  insertIntoscrape_videoCollection?: Maybe<Scrape_VideoInsertResponse>
  /** Adds one or more `scrape_web` records to the collection */
  insertIntoscrape_webCollection?: Maybe<Scrape_WebInsertResponse>
  /** Adds one or more `settings` records to the collection */
  insertIntosettingsCollection?: Maybe<SettingsInsertResponse>
  /** Adds one or more `slack_message` records to the collection */
  insertIntoslack_messageCollection?: Maybe<Slack_MessageInsertResponse>
  /** Adds one or more `slack_message_user` records to the collection */
  insertIntoslack_message_userCollection?: Maybe<Slack_Message_UserInsertResponse>
  /** Adds one or more `strategy` records to the collection */
  insertIntostrategyCollection?: Maybe<StrategyInsertResponse>
  /** Adds one or more `strategy_performance` records to the collection */
  insertIntostrategy_performanceCollection?: Maybe<Strategy_PerformanceInsertResponse>
  /** Adds one or more `timeframe` records to the collection */
  insertIntotimeframeCollection?: Maybe<TimeframeInsertResponse>
  /** Adds one or more `tv_alert` records to the collection */
  insertIntotv_alertCollection?: Maybe<Tv_AlertInsertResponse>
  /** Adds one or more `user` records to the collection */
  insertIntouserCollection?: Maybe<UserInsertResponse>
  /** Adds one or more `user_bot_agent` records to the collection */
  insertIntouser_bot_agentCollection?: Maybe<User_Bot_AgentInsertResponse>
  /** Adds one or more `user_bot_conversation` records to the collection */
  insertIntouser_bot_conversationCollection?: Maybe<User_Bot_ConversationInsertResponse>
  /** Adds one or more `user_profile_category` records to the collection */
  insertIntouser_profile_categoryCollection?: Maybe<User_Profile_CategoryInsertResponse>
  /** Adds one or more `user_profile_detail` records to the collection */
  insertIntouser_profile_detailCollection?: Maybe<User_Profile_DetailInsertResponse>
  /** Adds one or more `user_psych_event` records to the collection */
  insertIntouser_psych_eventCollection?: Maybe<User_Psych_EventInsertResponse>
  /** Adds one or more `user_watching` records to the collection */
  insertIntouser_watchingCollection?: Maybe<User_WatchingInsertResponse>
  /** Updates zero or more records in the `balance_snapshot` collection */
  updatebalance_snapshotCollection: Balance_SnapshotUpdateResponse
  /** Updates zero or more records in the `bot_agent` collection */
  updatebot_agentCollection: Bot_AgentUpdateResponse
  /** Updates zero or more records in the `bot_command` collection */
  updatebot_commandCollection: Bot_CommandUpdateResponse
  /** Updates zero or more records in the `candle` collection */
  updatecandleCollection: CandleUpdateResponse
  /** Updates zero or more records in the `emotion` collection */
  updateemotionCollection: EmotionUpdateResponse
  /** Updates zero or more records in the `market` collection */
  updatemarketCollection: MarketUpdateResponse
  /** Updates zero or more records in the `position` collection */
  updatepositionCollection: PositionUpdateResponse
  /** Updates zero or more records in the `profile_category` collection */
  updateprofile_categoryCollection: Profile_CategoryUpdateResponse
  /** Updates zero or more records in the `profile_detail` collection */
  updateprofile_detailCollection: Profile_DetailUpdateResponse
  /** Updates zero or more records in the `psych_event` collection */
  updatepsych_eventCollection: Psych_EventUpdateResponse
  /** Updates zero or more records in the `research` collection */
  updateresearchCollection: ResearchUpdateResponse
  /** Updates zero or more records in the `research_report` collection */
  updateresearch_reportCollection: Research_ReportUpdateResponse
  /** Updates zero or more records in the `scrape_target` collection */
  updatescrape_targetCollection: Scrape_TargetUpdateResponse
  /** Updates zero or more records in the `scrape_tweet` collection */
  updatescrape_tweetCollection: Scrape_TweetUpdateResponse
  /** Updates zero or more records in the `scrape_video` collection */
  updatescrape_videoCollection: Scrape_VideoUpdateResponse
  /** Updates zero or more records in the `scrape_web` collection */
  updatescrape_webCollection: Scrape_WebUpdateResponse
  /** Updates zero or more records in the `settings` collection */
  updatesettingsCollection: SettingsUpdateResponse
  /** Updates zero or more records in the `slack_message` collection */
  updateslack_messageCollection: Slack_MessageUpdateResponse
  /** Updates zero or more records in the `slack_message_user` collection */
  updateslack_message_userCollection: Slack_Message_UserUpdateResponse
  /** Updates zero or more records in the `strategy` collection */
  updatestrategyCollection: StrategyUpdateResponse
  /** Updates zero or more records in the `strategy_performance` collection */
  updatestrategy_performanceCollection: Strategy_PerformanceUpdateResponse
  /** Updates zero or more records in the `timeframe` collection */
  updatetimeframeCollection: TimeframeUpdateResponse
  /** Updates zero or more records in the `tv_alert` collection */
  updatetv_alertCollection: Tv_AlertUpdateResponse
  /** Updates zero or more records in the `user` collection */
  updateuserCollection: UserUpdateResponse
  /** Updates zero or more records in the `user_bot_agent` collection */
  updateuser_bot_agentCollection: User_Bot_AgentUpdateResponse
  /** Updates zero or more records in the `user_bot_conversation` collection */
  updateuser_bot_conversationCollection: User_Bot_ConversationUpdateResponse
  /** Updates zero or more records in the `user_profile_category` collection */
  updateuser_profile_categoryCollection: User_Profile_CategoryUpdateResponse
  /** Updates zero or more records in the `user_profile_detail` collection */
  updateuser_profile_detailCollection: User_Profile_DetailUpdateResponse
  /** Updates zero or more records in the `user_psych_event` collection */
  updateuser_psych_eventCollection: User_Psych_EventUpdateResponse
  /** Updates zero or more records in the `user_watching` collection */
  updateuser_watchingCollection: User_WatchingUpdateResponse
}

/** The root type for creating and mutating data */
export type MutationDeleteFrombalance_SnapshotCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Balance_SnapshotFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrombot_AgentCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Bot_AgentFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrombot_CommandCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Bot_CommandFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromcandleCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<CandleFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromemotionCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<EmotionFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrommarketCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<MarketFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrompositionCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<PositionFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromprofile_CategoryCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Profile_CategoryFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromprofile_DetailCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Profile_DetailFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrompsych_EventCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Psych_EventFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromresearchCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<ResearchFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromresearch_ReportCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Research_ReportFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromscrape_TargetCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Scrape_TargetFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromscrape_TweetCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Scrape_TweetFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromscrape_VideoCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Scrape_VideoFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromscrape_WebCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Scrape_WebFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromsettingsCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<SettingsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromslack_MessageCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Slack_MessageFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromslack_Message_UserCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Slack_Message_UserFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromstrategyCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<StrategyFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromstrategy_PerformanceCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Strategy_PerformanceFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromtimeframeCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<TimeframeFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromtv_AlertCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Tv_AlertFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromuserCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<UserFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromuser_Bot_AgentCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<User_Bot_AgentFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromuser_Bot_ConversationCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<User_Bot_ConversationFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromuser_Profile_CategoryCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<User_Profile_CategoryFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromuser_Profile_DetailCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<User_Profile_DetailFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromuser_Psych_EventCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<User_Psych_EventFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromuser_WatchingCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<User_WatchingFilter>
}

/** The root type for creating and mutating data */
export type MutationInsertIntobalance_SnapshotCollectionArgs = {
  objects: Array<Balance_SnapshotInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntobot_AgentCollectionArgs = {
  objects: Array<Bot_AgentInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntobot_CommandCollectionArgs = {
  objects: Array<Bot_CommandInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntocandleCollectionArgs = {
  objects: Array<CandleInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoemotionCollectionArgs = {
  objects: Array<EmotionInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntomarketCollectionArgs = {
  objects: Array<MarketInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntopositionCollectionArgs = {
  objects: Array<PositionInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoprofile_CategoryCollectionArgs = {
  objects: Array<Profile_CategoryInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoprofile_DetailCollectionArgs = {
  objects: Array<Profile_DetailInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntopsych_EventCollectionArgs = {
  objects: Array<Psych_EventInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoresearchCollectionArgs = {
  objects: Array<ResearchInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoresearch_ReportCollectionArgs = {
  objects: Array<Research_ReportInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoscrape_TargetCollectionArgs = {
  objects: Array<Scrape_TargetInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoscrape_TweetCollectionArgs = {
  objects: Array<Scrape_TweetInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoscrape_VideoCollectionArgs = {
  objects: Array<Scrape_VideoInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoscrape_WebCollectionArgs = {
  objects: Array<Scrape_WebInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntosettingsCollectionArgs = {
  objects: Array<SettingsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoslack_MessageCollectionArgs = {
  objects: Array<Slack_MessageInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoslack_Message_UserCollectionArgs = {
  objects: Array<Slack_Message_UserInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntostrategyCollectionArgs = {
  objects: Array<StrategyInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntostrategy_PerformanceCollectionArgs = {
  objects: Array<Strategy_PerformanceInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntotimeframeCollectionArgs = {
  objects: Array<TimeframeInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntotv_AlertCollectionArgs = {
  objects: Array<Tv_AlertInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntouserCollectionArgs = {
  objects: Array<UserInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntouser_Bot_AgentCollectionArgs = {
  objects: Array<User_Bot_AgentInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntouser_Bot_ConversationCollectionArgs = {
  objects: Array<User_Bot_ConversationInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntouser_Profile_CategoryCollectionArgs = {
  objects: Array<User_Profile_CategoryInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntouser_Profile_DetailCollectionArgs = {
  objects: Array<User_Profile_DetailInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntouser_Psych_EventCollectionArgs = {
  objects: Array<User_Psych_EventInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntouser_WatchingCollectionArgs = {
  objects: Array<User_WatchingInsertInput>
}

/** The root type for creating and mutating data */
export type MutationUpdatebalance_SnapshotCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Balance_SnapshotFilter>
  set: Balance_SnapshotUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatebot_AgentCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Bot_AgentFilter>
  set: Bot_AgentUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatebot_CommandCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Bot_CommandFilter>
  set: Bot_CommandUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatecandleCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<CandleFilter>
  set: CandleUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateemotionCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<EmotionFilter>
  set: EmotionUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatemarketCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<MarketFilter>
  set: MarketUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatepositionCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<PositionFilter>
  set: PositionUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateprofile_CategoryCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Profile_CategoryFilter>
  set: Profile_CategoryUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateprofile_DetailCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Profile_DetailFilter>
  set: Profile_DetailUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatepsych_EventCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Psych_EventFilter>
  set: Psych_EventUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateresearchCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<ResearchFilter>
  set: ResearchUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateresearch_ReportCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Research_ReportFilter>
  set: Research_ReportUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatescrape_TargetCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Scrape_TargetFilter>
  set: Scrape_TargetUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatescrape_TweetCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Scrape_TweetFilter>
  set: Scrape_TweetUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatescrape_VideoCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Scrape_VideoFilter>
  set: Scrape_VideoUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatescrape_WebCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Scrape_WebFilter>
  set: Scrape_WebUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatesettingsCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<SettingsFilter>
  set: SettingsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateslack_MessageCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Slack_MessageFilter>
  set: Slack_MessageUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateslack_Message_UserCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Slack_Message_UserFilter>
  set: Slack_Message_UserUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatestrategyCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<StrategyFilter>
  set: StrategyUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatestrategy_PerformanceCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Strategy_PerformanceFilter>
  set: Strategy_PerformanceUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatetimeframeCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<TimeframeFilter>
  set: TimeframeUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatetv_AlertCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<Tv_AlertFilter>
  set: Tv_AlertUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateuserCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<UserFilter>
  set: UserUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateuser_Bot_AgentCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<User_Bot_AgentFilter>
  set: User_Bot_AgentUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateuser_Bot_ConversationCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<User_Bot_ConversationFilter>
  set: User_Bot_ConversationUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateuser_Profile_CategoryCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<User_Profile_CategoryFilter>
  set: User_Profile_CategoryUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateuser_Profile_DetailCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<User_Profile_DetailFilter>
  set: User_Profile_DetailUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateuser_Psych_EventCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<User_Psych_EventFilter>
  set: User_Psych_EventUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateuser_WatchingCollectionArgs = {
  atMost?: Scalars['Int']['input']
  filter?: InputMaybe<User_WatchingFilter>
  set: User_WatchingUpdateInput
}

export type Node = {
  /** Retrieves a record by `ID` */
  nodeId: Scalars['ID']['output']
}

/** Boolean expression comparing fields on type "Opaque" */
export type OpaqueFilter = {
  eq?: InputMaybe<Scalars['Opaque']['input']>
  is?: InputMaybe<FilterIs>
}

/** Defines a per-field sorting order */
export const OrderByDirection = {
  /** Ascending order, nulls first */
  AscNullsFirst: 'AscNullsFirst',
  /** Ascending order, nulls last */
  AscNullsLast: 'AscNullsLast',
  /** Descending order, nulls first */
  DescNullsFirst: 'DescNullsFirst',
  /** Descending order, nulls last */
  DescNullsLast: 'DescNullsLast'
} as const

export type OrderByDirection = (typeof OrderByDirection)[keyof typeof OrderByDirection]
export type PageInfo = {
  __typename?: 'PageInfo'
  endCursor?: Maybe<Scalars['String']['output']>
  hasNextPage: Scalars['Boolean']['output']
  hasPreviousPage: Scalars['Boolean']['output']
  startCursor?: Maybe<Scalars['String']['output']>
}

/** The root type for querying data */
export type Query = {
  __typename?: 'Query'
  /** A pagable collection of type `balance_snapshot` */
  balance_snapshotCollection?: Maybe<Balance_SnapshotConnection>
  /** A pagable collection of type `bot_agent` */
  bot_agentCollection?: Maybe<Bot_AgentConnection>
  /** A pagable collection of type `bot_command` */
  bot_commandCollection?: Maybe<Bot_CommandConnection>
  /** A pagable collection of type `candle` */
  candleCollection?: Maybe<CandleConnection>
  /** A pagable collection of type `emotion` */
  emotionCollection?: Maybe<EmotionConnection>
  graphql_query?: Maybe<Scalars['JSON']['output']>
  /** A pagable collection of type `market` */
  marketCollection?: Maybe<MarketConnection>
  /** Retrieve a record by its `ID` */
  node?: Maybe<Node>
  /** A pagable collection of type `position` */
  positionCollection?: Maybe<PositionConnection>
  /** A pagable collection of type `profile_category` */
  profile_categoryCollection?: Maybe<Profile_CategoryConnection>
  /** A pagable collection of type `profile_detail` */
  profile_detailCollection?: Maybe<Profile_DetailConnection>
  /** A pagable collection of type `psych_event` */
  psych_eventCollection?: Maybe<Psych_EventConnection>
  /** A pagable collection of type `research` */
  researchCollection?: Maybe<ResearchConnection>
  /** A pagable collection of type `research_report` */
  research_reportCollection?: Maybe<Research_ReportConnection>
  /** A pagable collection of type `scrape_target` */
  scrape_targetCollection?: Maybe<Scrape_TargetConnection>
  /** A pagable collection of type `scrape_tweet` */
  scrape_tweetCollection?: Maybe<Scrape_TweetConnection>
  /** A pagable collection of type `scrape_video` */
  scrape_videoCollection?: Maybe<Scrape_VideoConnection>
  /** A pagable collection of type `scrape_web` */
  scrape_webCollection?: Maybe<Scrape_WebConnection>
  /** A pagable collection of type `settings` */
  settingsCollection?: Maybe<SettingsConnection>
  /** A pagable collection of type `slack_message` */
  slack_messageCollection?: Maybe<Slack_MessageConnection>
  /** A pagable collection of type `slack_message_user` */
  slack_message_userCollection?: Maybe<Slack_Message_UserConnection>
  /** A pagable collection of type `strategy` */
  strategyCollection?: Maybe<StrategyConnection>
  /** A pagable collection of type `strategy_performance` */
  strategy_performanceCollection?: Maybe<Strategy_PerformanceConnection>
  /** A pagable collection of type `timeframe` */
  timeframeCollection?: Maybe<TimeframeConnection>
  /** A pagable collection of type `tv_alert` */
  tv_alertCollection?: Maybe<Tv_AlertConnection>
  /** A pagable collection of type `user` */
  userCollection?: Maybe<UserConnection>
  /** A pagable collection of type `user_bot_agent` */
  user_bot_agentCollection?: Maybe<User_Bot_AgentConnection>
  /** A pagable collection of type `user_bot_conversation` */
  user_bot_conversationCollection?: Maybe<User_Bot_ConversationConnection>
  /** A pagable collection of type `user_profile_category` */
  user_profile_categoryCollection?: Maybe<User_Profile_CategoryConnection>
  /** A pagable collection of type `user_profile_detail` */
  user_profile_detailCollection?: Maybe<User_Profile_DetailConnection>
  /** A pagable collection of type `user_psych_event` */
  user_psych_eventCollection?: Maybe<User_Psych_EventConnection>
  /** A pagable collection of type `user_watching` */
  user_watchingCollection?: Maybe<User_WatchingConnection>
}

/** The root type for querying data */
export type QueryBalance_SnapshotCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Balance_SnapshotFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Balance_SnapshotOrderBy>>
}

/** The root type for querying data */
export type QueryBot_AgentCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Bot_AgentFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Bot_AgentOrderBy>>
}

/** The root type for querying data */
export type QueryBot_CommandCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Bot_CommandFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Bot_CommandOrderBy>>
}

/** The root type for querying data */
export type QueryCandleCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<CandleFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<CandleOrderBy>>
}

/** The root type for querying data */
export type QueryEmotionCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<EmotionFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<EmotionOrderBy>>
}

/** The root type for querying data */
export type QueryGraphql_QueryArgs = {
  query: Scalars['String']['input']
  variables?: InputMaybe<Scalars['JSON']['input']>
}

/** The root type for querying data */
export type QueryMarketCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<MarketFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<MarketOrderBy>>
}

/** The root type for querying data */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input']
}

/** The root type for querying data */
export type QueryPositionCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<PositionFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<PositionOrderBy>>
}

/** The root type for querying data */
export type QueryProfile_CategoryCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Profile_CategoryFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Profile_CategoryOrderBy>>
}

/** The root type for querying data */
export type QueryProfile_DetailCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Profile_DetailFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Profile_DetailOrderBy>>
}

/** The root type for querying data */
export type QueryPsych_EventCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Psych_EventFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Psych_EventOrderBy>>
}

/** The root type for querying data */
export type QueryResearchCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<ResearchFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<ResearchOrderBy>>
}

/** The root type for querying data */
export type QueryResearch_ReportCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Research_ReportFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Research_ReportOrderBy>>
}

/** The root type for querying data */
export type QueryScrape_TargetCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Scrape_TargetFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Scrape_TargetOrderBy>>
}

/** The root type for querying data */
export type QueryScrape_TweetCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Scrape_TweetFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Scrape_TweetOrderBy>>
}

/** The root type for querying data */
export type QueryScrape_VideoCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Scrape_VideoFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Scrape_VideoOrderBy>>
}

/** The root type for querying data */
export type QueryScrape_WebCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Scrape_WebFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Scrape_WebOrderBy>>
}

/** The root type for querying data */
export type QuerySettingsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<SettingsFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<SettingsOrderBy>>
}

/** The root type for querying data */
export type QuerySlack_MessageCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Slack_MessageFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Slack_MessageOrderBy>>
}

/** The root type for querying data */
export type QuerySlack_Message_UserCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Slack_Message_UserFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Slack_Message_UserOrderBy>>
}

/** The root type for querying data */
export type QueryStrategyCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<StrategyFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<StrategyOrderBy>>
}

/** The root type for querying data */
export type QueryStrategy_PerformanceCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Strategy_PerformanceFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Strategy_PerformanceOrderBy>>
}

/** The root type for querying data */
export type QueryTimeframeCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<TimeframeFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<TimeframeOrderBy>>
}

/** The root type for querying data */
export type QueryTv_AlertCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Tv_AlertFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Tv_AlertOrderBy>>
}

/** The root type for querying data */
export type QueryUserCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<UserFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserOrderBy>>
}

/** The root type for querying data */
export type QueryUser_Bot_AgentCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_Bot_AgentFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_Bot_AgentOrderBy>>
}

/** The root type for querying data */
export type QueryUser_Bot_ConversationCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_Bot_ConversationFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_Bot_ConversationOrderBy>>
}

/** The root type for querying data */
export type QueryUser_Profile_CategoryCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_Profile_CategoryFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_Profile_CategoryOrderBy>>
}

/** The root type for querying data */
export type QueryUser_Profile_DetailCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_Profile_DetailFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_Profile_DetailOrderBy>>
}

/** The root type for querying data */
export type QueryUser_Psych_EventCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_Psych_EventFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_Psych_EventOrderBy>>
}

/** The root type for querying data */
export type QueryUser_WatchingCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_WatchingFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_WatchingOrderBy>>
}

/** Boolean expression comparing fields on type "String" */
export type StringFilter = {
  eq?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  ilike?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<Scalars['String']['input']>>
  iregex?: InputMaybe<Scalars['String']['input']>
  is?: InputMaybe<FilterIs>
  like?: InputMaybe<Scalars['String']['input']>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
  neq?: InputMaybe<Scalars['String']['input']>
  regex?: InputMaybe<Scalars['String']['input']>
  startsWith?: InputMaybe<Scalars['String']['input']>
}

/** Boolean expression comparing fields on type "StringList" */
export type StringListFilter = {
  containedBy?: InputMaybe<Array<Scalars['String']['input']>>
  contains?: InputMaybe<Array<Scalars['String']['input']>>
  eq?: InputMaybe<Array<Scalars['String']['input']>>
  is?: InputMaybe<FilterIs>
  overlaps?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Boolean expression comparing fields on type "Time" */
export type TimeFilter = {
  eq?: InputMaybe<Scalars['Time']['input']>
  gt?: InputMaybe<Scalars['Time']['input']>
  gte?: InputMaybe<Scalars['Time']['input']>
  in?: InputMaybe<Array<Scalars['Time']['input']>>
  is?: InputMaybe<FilterIs>
  lt?: InputMaybe<Scalars['Time']['input']>
  lte?: InputMaybe<Scalars['Time']['input']>
  neq?: InputMaybe<Scalars['Time']['input']>
}

/** Boolean expression comparing fields on type "TimeList" */
export type TimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Time']['input']>>
  contains?: InputMaybe<Array<Scalars['Time']['input']>>
  eq?: InputMaybe<Array<Scalars['Time']['input']>>
  is?: InputMaybe<FilterIs>
  overlaps?: InputMaybe<Array<Scalars['Time']['input']>>
}

/** Boolean expression comparing fields on type "UUID" */
export type UuidFilter = {
  eq?: InputMaybe<Scalars['UUID']['input']>
  in?: InputMaybe<Array<Scalars['UUID']['input']>>
  is?: InputMaybe<FilterIs>
  neq?: InputMaybe<Scalars['UUID']['input']>
}

/** Boolean expression comparing fields on type "UUIDList" */
export type UuidListFilter = {
  containedBy?: InputMaybe<Array<Scalars['UUID']['input']>>
  contains?: InputMaybe<Array<Scalars['UUID']['input']>>
  eq?: InputMaybe<Array<Scalars['UUID']['input']>>
  is?: InputMaybe<FilterIs>
  overlaps?: InputMaybe<Array<Scalars['UUID']['input']>>
}

export type Balance_Snapshot = Node & {
  __typename?: 'balance_snapshot'
  assets?: Maybe<Scalars['JSON']['output']>
  assets_live?: Maybe<Scalars['JSON']['output']>
  created_at?: Maybe<Scalars['Datetime']['output']>
  id: Scalars['Int']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  total_amount?: Maybe<Scalars['BigFloat']['output']>
  total_amount_live?: Maybe<Scalars['BigFloat']['output']>
  usd_amount?: Maybe<Scalars['BigFloat']['output']>
  user?: Maybe<User>
  user_id?: Maybe<Scalars['Int']['output']>
}

export type Balance_SnapshotConnection = {
  __typename?: 'balance_snapshotConnection'
  edges: Array<Balance_SnapshotEdge>
  pageInfo: PageInfo
}

export type Balance_SnapshotDeleteResponse = {
  __typename?: 'balance_snapshotDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Balance_Snapshot>
}

export type Balance_SnapshotEdge = {
  __typename?: 'balance_snapshotEdge'
  cursor: Scalars['String']['output']
  node: Balance_Snapshot
}

export type Balance_SnapshotFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Balance_SnapshotFilter>>
  created_at?: InputMaybe<DatetimeFilter>
  id?: InputMaybe<IntFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Balance_SnapshotFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Balance_SnapshotFilter>>
  total_amount?: InputMaybe<BigFloatFilter>
  total_amount_live?: InputMaybe<BigFloatFilter>
  usd_amount?: InputMaybe<BigFloatFilter>
  user_id?: InputMaybe<IntFilter>
}

export type Balance_SnapshotInsertInput = {
  assets?: InputMaybe<Scalars['JSON']['input']>
  assets_live?: InputMaybe<Scalars['JSON']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  total_amount?: InputMaybe<Scalars['BigFloat']['input']>
  total_amount_live?: InputMaybe<Scalars['BigFloat']['input']>
  usd_amount?: InputMaybe<Scalars['BigFloat']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
}

export type Balance_SnapshotInsertResponse = {
  __typename?: 'balance_snapshotInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Balance_Snapshot>
}

export type Balance_SnapshotOrderBy = {
  created_at?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  total_amount?: InputMaybe<OrderByDirection>
  total_amount_live?: InputMaybe<OrderByDirection>
  usd_amount?: InputMaybe<OrderByDirection>
  user_id?: InputMaybe<OrderByDirection>
}

export type Balance_SnapshotUpdateInput = {
  assets?: InputMaybe<Scalars['JSON']['input']>
  assets_live?: InputMaybe<Scalars['JSON']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  total_amount?: InputMaybe<Scalars['BigFloat']['input']>
  total_amount_live?: InputMaybe<Scalars['BigFloat']['input']>
  usd_amount?: InputMaybe<Scalars['BigFloat']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
}

export type Balance_SnapshotUpdateResponse = {
  __typename?: 'balance_snapshotUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Balance_Snapshot>
}

export type Bot_Agent = Node & {
  __typename?: 'bot_agent'
  bot_commandCollection?: Maybe<Bot_CommandConnection>
  buffer_size?: Maybe<Scalars['Int']['output']>
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  prompt?: Maybe<Scalars['String']['output']>
  researchCollection?: Maybe<ResearchConnection>
  summary_prompt?: Maybe<Scalars['String']['output']>
  user_bot_agentCollection?: Maybe<User_Bot_AgentConnection>
}

export type Bot_AgentBot_CommandCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Bot_CommandFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Bot_CommandOrderBy>>
}

export type Bot_AgentResearchCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<ResearchFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<ResearchOrderBy>>
}

export type Bot_AgentUser_Bot_AgentCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_Bot_AgentFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_Bot_AgentOrderBy>>
}

export type Bot_AgentConnection = {
  __typename?: 'bot_agentConnection'
  edges: Array<Bot_AgentEdge>
  pageInfo: PageInfo
}

export type Bot_AgentDeleteResponse = {
  __typename?: 'bot_agentDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Bot_Agent>
}

export type Bot_AgentEdge = {
  __typename?: 'bot_agentEdge'
  cursor: Scalars['String']['output']
  node: Bot_Agent
}

export type Bot_AgentFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Bot_AgentFilter>>
  buffer_size?: InputMaybe<IntFilter>
  id?: InputMaybe<IntFilter>
  name?: InputMaybe<StringFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Bot_AgentFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Bot_AgentFilter>>
  prompt?: InputMaybe<StringFilter>
  summary_prompt?: InputMaybe<StringFilter>
}

export type Bot_AgentInsertInput = {
  buffer_size?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  prompt?: InputMaybe<Scalars['String']['input']>
  summary_prompt?: InputMaybe<Scalars['String']['input']>
}

export type Bot_AgentInsertResponse = {
  __typename?: 'bot_agentInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Bot_Agent>
}

export type Bot_AgentOrderBy = {
  buffer_size?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  name?: InputMaybe<OrderByDirection>
  prompt?: InputMaybe<OrderByDirection>
  summary_prompt?: InputMaybe<OrderByDirection>
}

export type Bot_AgentUpdateInput = {
  buffer_size?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  prompt?: InputMaybe<Scalars['String']['input']>
  summary_prompt?: InputMaybe<Scalars['String']['input']>
}

export type Bot_AgentUpdateResponse = {
  __typename?: 'bot_agentUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Bot_Agent>
}

export type Bot_Command = Node & {
  __typename?: 'bot_command'
  bot_agent?: Maybe<Bot_Agent>
  bot_agent_id?: Maybe<Scalars['Int']['output']>
  command: Scalars['String']['output']
  id: Scalars['Int']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  prompt: Scalars['String']['output']
}

export type Bot_CommandConnection = {
  __typename?: 'bot_commandConnection'
  edges: Array<Bot_CommandEdge>
  pageInfo: PageInfo
}

export type Bot_CommandDeleteResponse = {
  __typename?: 'bot_commandDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Bot_Command>
}

export type Bot_CommandEdge = {
  __typename?: 'bot_commandEdge'
  cursor: Scalars['String']['output']
  node: Bot_Command
}

export type Bot_CommandFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Bot_CommandFilter>>
  bot_agent_id?: InputMaybe<IntFilter>
  command?: InputMaybe<StringFilter>
  id?: InputMaybe<IntFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Bot_CommandFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Bot_CommandFilter>>
  prompt?: InputMaybe<StringFilter>
}

export type Bot_CommandInsertInput = {
  bot_agent_id?: InputMaybe<Scalars['Int']['input']>
  command?: InputMaybe<Scalars['String']['input']>
  prompt?: InputMaybe<Scalars['String']['input']>
}

export type Bot_CommandInsertResponse = {
  __typename?: 'bot_commandInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Bot_Command>
}

export type Bot_CommandOrderBy = {
  bot_agent_id?: InputMaybe<OrderByDirection>
  command?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  prompt?: InputMaybe<OrderByDirection>
}

export type Bot_CommandUpdateInput = {
  bot_agent_id?: InputMaybe<Scalars['Int']['input']>
  command?: InputMaybe<Scalars['String']['input']>
  prompt?: InputMaybe<Scalars['String']['input']>
}

export type Bot_CommandUpdateResponse = {
  __typename?: 'bot_commandUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Bot_Command>
}

export type Candle = Node & {
  __typename?: 'candle'
  candle?: Maybe<Candle>
  candleCollection?: Maybe<CandleConnection>
  close?: Maybe<Scalars['BigFloat']['output']>
  created_at?: Maybe<Scalars['Datetime']['output']>
  data?: Maybe<Scalars['JSON']['output']>
  debug?: Maybe<Scalars['JSON']['output']>
  digestion_version?: Maybe<Scalars['String']['output']>
  high?: Maybe<Scalars['BigFloat']['output']>
  id: Scalars['Int']['output']
  low?: Maybe<Scalars['BigFloat']['output']>
  market?: Maybe<Market>
  market_activity_score?: Maybe<Scalars['BigFloat']['output']>
  market_id?: Maybe<Scalars['Int']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  open?: Maybe<Scalars['BigFloat']['output']>
  opened_at?: Maybe<Scalars['Datetime']['output']>
  opened_ts?: Maybe<Scalars['BigFloat']['output']>
  percent_remaining?: Maybe<Scalars['BigFloat']['output']>
  prev_candle_id?: Maybe<Scalars['Int']['output']>
  slack_messageCollection?: Maybe<Slack_MessageConnection>
  status?: Maybe<Scalars['String']['output']>
  timeframe?: Maybe<Timeframe>
  timeframe_id?: Maybe<Scalars['Int']['output']>
  tv_alert?: Maybe<Tv_Alert>
  tv_alert_id?: Maybe<Scalars['Int']['output']>
  volume?: Maybe<Scalars['BigFloat']['output']>
}

export type CandleCandleCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<CandleFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<CandleOrderBy>>
}

export type CandleSlack_MessageCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Slack_MessageFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Slack_MessageOrderBy>>
}

export type CandleConnection = {
  __typename?: 'candleConnection'
  edges: Array<CandleEdge>
  pageInfo: PageInfo
}

export type CandleDeleteResponse = {
  __typename?: 'candleDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Candle>
}

export type CandleEdge = {
  __typename?: 'candleEdge'
  cursor: Scalars['String']['output']
  node: Candle
}

export type CandleFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<CandleFilter>>
  close?: InputMaybe<BigFloatFilter>
  created_at?: InputMaybe<DatetimeFilter>
  digestion_version?: InputMaybe<StringFilter>
  high?: InputMaybe<BigFloatFilter>
  id?: InputMaybe<IntFilter>
  low?: InputMaybe<BigFloatFilter>
  market_activity_score?: InputMaybe<BigFloatFilter>
  market_id?: InputMaybe<IntFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<CandleFilter>
  open?: InputMaybe<BigFloatFilter>
  opened_at?: InputMaybe<DatetimeFilter>
  opened_ts?: InputMaybe<BigFloatFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<CandleFilter>>
  percent_remaining?: InputMaybe<BigFloatFilter>
  prev_candle_id?: InputMaybe<IntFilter>
  status?: InputMaybe<StringFilter>
  timeframe_id?: InputMaybe<IntFilter>
  tv_alert_id?: InputMaybe<IntFilter>
  volume?: InputMaybe<BigFloatFilter>
}

export type CandleInsertInput = {
  close?: InputMaybe<Scalars['BigFloat']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  debug?: InputMaybe<Scalars['JSON']['input']>
  digestion_version?: InputMaybe<Scalars['String']['input']>
  high?: InputMaybe<Scalars['BigFloat']['input']>
  low?: InputMaybe<Scalars['BigFloat']['input']>
  market_activity_score?: InputMaybe<Scalars['BigFloat']['input']>
  market_id?: InputMaybe<Scalars['Int']['input']>
  open?: InputMaybe<Scalars['BigFloat']['input']>
  opened_at?: InputMaybe<Scalars['Datetime']['input']>
  opened_ts?: InputMaybe<Scalars['BigFloat']['input']>
  percent_remaining?: InputMaybe<Scalars['BigFloat']['input']>
  prev_candle_id?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  timeframe_id?: InputMaybe<Scalars['Int']['input']>
  tv_alert_id?: InputMaybe<Scalars['Int']['input']>
  volume?: InputMaybe<Scalars['BigFloat']['input']>
}

export type CandleInsertResponse = {
  __typename?: 'candleInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Candle>
}

export type CandleOrderBy = {
  close?: InputMaybe<OrderByDirection>
  created_at?: InputMaybe<OrderByDirection>
  digestion_version?: InputMaybe<OrderByDirection>
  high?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  low?: InputMaybe<OrderByDirection>
  market_activity_score?: InputMaybe<OrderByDirection>
  market_id?: InputMaybe<OrderByDirection>
  open?: InputMaybe<OrderByDirection>
  opened_at?: InputMaybe<OrderByDirection>
  opened_ts?: InputMaybe<OrderByDirection>
  percent_remaining?: InputMaybe<OrderByDirection>
  prev_candle_id?: InputMaybe<OrderByDirection>
  status?: InputMaybe<OrderByDirection>
  timeframe_id?: InputMaybe<OrderByDirection>
  tv_alert_id?: InputMaybe<OrderByDirection>
  volume?: InputMaybe<OrderByDirection>
}

export type CandleUpdateInput = {
  close?: InputMaybe<Scalars['BigFloat']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  debug?: InputMaybe<Scalars['JSON']['input']>
  digestion_version?: InputMaybe<Scalars['String']['input']>
  high?: InputMaybe<Scalars['BigFloat']['input']>
  low?: InputMaybe<Scalars['BigFloat']['input']>
  market_activity_score?: InputMaybe<Scalars['BigFloat']['input']>
  market_id?: InputMaybe<Scalars['Int']['input']>
  open?: InputMaybe<Scalars['BigFloat']['input']>
  opened_at?: InputMaybe<Scalars['Datetime']['input']>
  opened_ts?: InputMaybe<Scalars['BigFloat']['input']>
  percent_remaining?: InputMaybe<Scalars['BigFloat']['input']>
  prev_candle_id?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  timeframe_id?: InputMaybe<Scalars['Int']['input']>
  tv_alert_id?: InputMaybe<Scalars['Int']['input']>
  volume?: InputMaybe<Scalars['BigFloat']['input']>
}

export type CandleUpdateResponse = {
  __typename?: 'candleUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Candle>
}

export type Emotion = Node & {
  __typename?: 'emotion'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  name?: Maybe<Scalars['String']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
}

export type EmotionConnection = {
  __typename?: 'emotionConnection'
  edges: Array<EmotionEdge>
  pageInfo: PageInfo
}

export type EmotionDeleteResponse = {
  __typename?: 'emotionDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Emotion>
}

export type EmotionEdge = {
  __typename?: 'emotionEdge'
  cursor: Scalars['String']['output']
  node: Emotion
}

export type EmotionFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<EmotionFilter>>
  description?: InputMaybe<StringFilter>
  id?: InputMaybe<IntFilter>
  name?: InputMaybe<StringFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<EmotionFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<EmotionFilter>>
}

export type EmotionInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type EmotionInsertResponse = {
  __typename?: 'emotionInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Emotion>
}

export type EmotionOrderBy = {
  description?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  name?: InputMaybe<OrderByDirection>
}

export type EmotionUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type EmotionUpdateResponse = {
  __typename?: 'emotionUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Emotion>
}

export type Market = Node & {
  __typename?: 'market'
  candleCollection?: Maybe<CandleConnection>
  created_at?: Maybe<Scalars['Datetime']['output']>
  data?: Maybe<Scalars['JSON']['output']>
  id: Scalars['Int']['output']
  last_update_at?: Maybe<Scalars['Datetime']['output']>
  market_activity_score_1d?: Maybe<Scalars['BigFloat']['output']>
  market_activity_score_1h?: Maybe<Scalars['BigFloat']['output']>
  name?: Maybe<Scalars['String']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  positionCollection?: Maybe<PositionConnection>
  price?: Maybe<Scalars['BigFloat']['output']>
  sentiment?: Maybe<Scalars['String']['output']>
  sentiment_update_at?: Maybe<Scalars['Datetime']['output']>
  short_name?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  strategy_performanceCollection?: Maybe<Strategy_PerformanceConnection>
  ticker: Scalars['String']['output']
  trend_status?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  user_watchingCollection?: Maybe<User_WatchingConnection>
}

export type MarketCandleCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<CandleFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<CandleOrderBy>>
}

export type MarketPositionCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<PositionFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<PositionOrderBy>>
}

export type MarketStrategy_PerformanceCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Strategy_PerformanceFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Strategy_PerformanceOrderBy>>
}

export type MarketUser_WatchingCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_WatchingFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_WatchingOrderBy>>
}

export type MarketConnection = {
  __typename?: 'marketConnection'
  edges: Array<MarketEdge>
  pageInfo: PageInfo
}

export type MarketDeleteResponse = {
  __typename?: 'marketDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Market>
}

export type MarketEdge = {
  __typename?: 'marketEdge'
  cursor: Scalars['String']['output']
  node: Market
}

export type MarketFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<MarketFilter>>
  created_at?: InputMaybe<DatetimeFilter>
  id?: InputMaybe<IntFilter>
  last_update_at?: InputMaybe<DatetimeFilter>
  market_activity_score_1d?: InputMaybe<BigFloatFilter>
  market_activity_score_1h?: InputMaybe<BigFloatFilter>
  name?: InputMaybe<StringFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<MarketFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<MarketFilter>>
  price?: InputMaybe<BigFloatFilter>
  sentiment?: InputMaybe<StringFilter>
  sentiment_update_at?: InputMaybe<DatetimeFilter>
  short_name?: InputMaybe<StringFilter>
  status?: InputMaybe<StringFilter>
  ticker?: InputMaybe<StringFilter>
  trend_status?: InputMaybe<StringFilter>
  type?: InputMaybe<StringFilter>
}

export type MarketInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  last_update_at?: InputMaybe<Scalars['Datetime']['input']>
  market_activity_score_1d?: InputMaybe<Scalars['BigFloat']['input']>
  market_activity_score_1h?: InputMaybe<Scalars['BigFloat']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['BigFloat']['input']>
  sentiment?: InputMaybe<Scalars['String']['input']>
  sentiment_update_at?: InputMaybe<Scalars['Datetime']['input']>
  short_name?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  ticker?: InputMaybe<Scalars['String']['input']>
  trend_status?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type MarketInsertResponse = {
  __typename?: 'marketInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Market>
}

export type MarketOrderBy = {
  created_at?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  last_update_at?: InputMaybe<OrderByDirection>
  market_activity_score_1d?: InputMaybe<OrderByDirection>
  market_activity_score_1h?: InputMaybe<OrderByDirection>
  name?: InputMaybe<OrderByDirection>
  price?: InputMaybe<OrderByDirection>
  sentiment?: InputMaybe<OrderByDirection>
  sentiment_update_at?: InputMaybe<OrderByDirection>
  short_name?: InputMaybe<OrderByDirection>
  status?: InputMaybe<OrderByDirection>
  ticker?: InputMaybe<OrderByDirection>
  trend_status?: InputMaybe<OrderByDirection>
  type?: InputMaybe<OrderByDirection>
}

export type MarketUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  last_update_at?: InputMaybe<Scalars['Datetime']['input']>
  market_activity_score_1d?: InputMaybe<Scalars['BigFloat']['input']>
  market_activity_score_1h?: InputMaybe<Scalars['BigFloat']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['BigFloat']['input']>
  sentiment?: InputMaybe<Scalars['String']['input']>
  sentiment_update_at?: InputMaybe<Scalars['Datetime']['input']>
  short_name?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  ticker?: InputMaybe<Scalars['String']['input']>
  trend_status?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type MarketUpdateResponse = {
  __typename?: 'marketUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Market>
}

export type Position = Node & {
  __typename?: 'position'
  age?: Maybe<Scalars['Int']['output']>
  amount?: Maybe<Scalars['BigFloat']['output']>
  analysis?: Maybe<Scalars['String']['output']>
  closed?: Maybe<Scalars['BigFloat']['output']>
  closed_at?: Maybe<Scalars['Datetime']['output']>
  closed_ts?: Maybe<Scalars['BigFloat']['output']>
  code?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['Datetime']['output']>
  data?: Maybe<Scalars['JSON']['output']>
  description?: Maybe<Scalars['String']['output']>
  do_stop_loss?: Maybe<Scalars['Boolean']['output']>
  do_take_profit?: Maybe<Scalars['Boolean']['output']>
  entered?: Maybe<Scalars['BigFloat']['output']>
  entry?: Maybe<Scalars['BigFloat']['output']>
  id: Scalars['Int']['output']
  is_cleared?: Maybe<Scalars['Boolean']['output']>
  is_live: Scalars['Boolean']['output']
  market?: Maybe<Market>
  market_id?: Maybe<Scalars['Int']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  opened_at?: Maybe<Scalars['Datetime']['output']>
  opened_ts?: Maybe<Scalars['BigFloat']['output']>
  profit?: Maybe<Scalars['BigFloat']['output']>
  result?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  stop_loss?: Maybe<Scalars['BigFloat']['output']>
  take_profit?: Maybe<Scalars['BigFloat']['output']>
  timeframe?: Maybe<Timeframe>
  timeframe_id?: Maybe<Scalars['Int']['output']>
  usd_amount?: Maybe<Scalars['BigFloat']['output']>
  user?: Maybe<User>
  user_id?: Maybe<Scalars['Int']['output']>
}

export type PositionConnection = {
  __typename?: 'positionConnection'
  edges: Array<PositionEdge>
  pageInfo: PageInfo
}

export type PositionDeleteResponse = {
  __typename?: 'positionDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Position>
}

export type PositionEdge = {
  __typename?: 'positionEdge'
  cursor: Scalars['String']['output']
  node: Position
}

export type PositionFilter = {
  age?: InputMaybe<IntFilter>
  amount?: InputMaybe<BigFloatFilter>
  analysis?: InputMaybe<StringFilter>
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<PositionFilter>>
  closed?: InputMaybe<BigFloatFilter>
  closed_at?: InputMaybe<DatetimeFilter>
  closed_ts?: InputMaybe<BigFloatFilter>
  code?: InputMaybe<StringFilter>
  created_at?: InputMaybe<DatetimeFilter>
  description?: InputMaybe<StringFilter>
  do_stop_loss?: InputMaybe<BooleanFilter>
  do_take_profit?: InputMaybe<BooleanFilter>
  entered?: InputMaybe<BigFloatFilter>
  entry?: InputMaybe<BigFloatFilter>
  id?: InputMaybe<IntFilter>
  is_cleared?: InputMaybe<BooleanFilter>
  is_live?: InputMaybe<BooleanFilter>
  market_id?: InputMaybe<IntFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<PositionFilter>
  opened_at?: InputMaybe<DatetimeFilter>
  opened_ts?: InputMaybe<BigFloatFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<PositionFilter>>
  profit?: InputMaybe<BigFloatFilter>
  result?: InputMaybe<StringFilter>
  status?: InputMaybe<StringFilter>
  stop_loss?: InputMaybe<BigFloatFilter>
  take_profit?: InputMaybe<BigFloatFilter>
  timeframe_id?: InputMaybe<IntFilter>
  usd_amount?: InputMaybe<BigFloatFilter>
  user_id?: InputMaybe<IntFilter>
}

export type PositionInsertInput = {
  age?: InputMaybe<Scalars['Int']['input']>
  amount?: InputMaybe<Scalars['BigFloat']['input']>
  analysis?: InputMaybe<Scalars['String']['input']>
  closed?: InputMaybe<Scalars['BigFloat']['input']>
  closed_at?: InputMaybe<Scalars['Datetime']['input']>
  closed_ts?: InputMaybe<Scalars['BigFloat']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  do_stop_loss?: InputMaybe<Scalars['Boolean']['input']>
  do_take_profit?: InputMaybe<Scalars['Boolean']['input']>
  entered?: InputMaybe<Scalars['BigFloat']['input']>
  entry?: InputMaybe<Scalars['BigFloat']['input']>
  is_cleared?: InputMaybe<Scalars['Boolean']['input']>
  is_live?: InputMaybe<Scalars['Boolean']['input']>
  market_id?: InputMaybe<Scalars['Int']['input']>
  opened_at?: InputMaybe<Scalars['Datetime']['input']>
  opened_ts?: InputMaybe<Scalars['BigFloat']['input']>
  profit?: InputMaybe<Scalars['BigFloat']['input']>
  result?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  stop_loss?: InputMaybe<Scalars['BigFloat']['input']>
  take_profit?: InputMaybe<Scalars['BigFloat']['input']>
  timeframe_id?: InputMaybe<Scalars['Int']['input']>
  usd_amount?: InputMaybe<Scalars['BigFloat']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
}

export type PositionInsertResponse = {
  __typename?: 'positionInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Position>
}

export type PositionOrderBy = {
  age?: InputMaybe<OrderByDirection>
  amount?: InputMaybe<OrderByDirection>
  analysis?: InputMaybe<OrderByDirection>
  closed?: InputMaybe<OrderByDirection>
  closed_at?: InputMaybe<OrderByDirection>
  closed_ts?: InputMaybe<OrderByDirection>
  code?: InputMaybe<OrderByDirection>
  created_at?: InputMaybe<OrderByDirection>
  description?: InputMaybe<OrderByDirection>
  do_stop_loss?: InputMaybe<OrderByDirection>
  do_take_profit?: InputMaybe<OrderByDirection>
  entered?: InputMaybe<OrderByDirection>
  entry?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  is_cleared?: InputMaybe<OrderByDirection>
  is_live?: InputMaybe<OrderByDirection>
  market_id?: InputMaybe<OrderByDirection>
  opened_at?: InputMaybe<OrderByDirection>
  opened_ts?: InputMaybe<OrderByDirection>
  profit?: InputMaybe<OrderByDirection>
  result?: InputMaybe<OrderByDirection>
  status?: InputMaybe<OrderByDirection>
  stop_loss?: InputMaybe<OrderByDirection>
  take_profit?: InputMaybe<OrderByDirection>
  timeframe_id?: InputMaybe<OrderByDirection>
  usd_amount?: InputMaybe<OrderByDirection>
  user_id?: InputMaybe<OrderByDirection>
}

export type PositionUpdateInput = {
  age?: InputMaybe<Scalars['Int']['input']>
  amount?: InputMaybe<Scalars['BigFloat']['input']>
  analysis?: InputMaybe<Scalars['String']['input']>
  closed?: InputMaybe<Scalars['BigFloat']['input']>
  closed_at?: InputMaybe<Scalars['Datetime']['input']>
  closed_ts?: InputMaybe<Scalars['BigFloat']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  do_stop_loss?: InputMaybe<Scalars['Boolean']['input']>
  do_take_profit?: InputMaybe<Scalars['Boolean']['input']>
  entered?: InputMaybe<Scalars['BigFloat']['input']>
  entry?: InputMaybe<Scalars['BigFloat']['input']>
  is_cleared?: InputMaybe<Scalars['Boolean']['input']>
  is_live?: InputMaybe<Scalars['Boolean']['input']>
  market_id?: InputMaybe<Scalars['Int']['input']>
  opened_at?: InputMaybe<Scalars['Datetime']['input']>
  opened_ts?: InputMaybe<Scalars['BigFloat']['input']>
  profit?: InputMaybe<Scalars['BigFloat']['input']>
  result?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  stop_loss?: InputMaybe<Scalars['BigFloat']['input']>
  take_profit?: InputMaybe<Scalars['BigFloat']['input']>
  timeframe_id?: InputMaybe<Scalars['Int']['input']>
  usd_amount?: InputMaybe<Scalars['BigFloat']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
}

export type PositionUpdateResponse = {
  __typename?: 'positionUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Position>
}

export type Profile_Category = Node & {
  __typename?: 'profile_category'
  description?: Maybe<Scalars['String']['output']>
  high_result?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  low_result?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  profile_detailCollection?: Maybe<Profile_DetailConnection>
  user_profile_categoryCollection?: Maybe<User_Profile_CategoryConnection>
}

export type Profile_CategoryProfile_DetailCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Profile_DetailFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Profile_DetailOrderBy>>
}

export type Profile_CategoryUser_Profile_CategoryCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_Profile_CategoryFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_Profile_CategoryOrderBy>>
}

export type Profile_CategoryConnection = {
  __typename?: 'profile_categoryConnection'
  edges: Array<Profile_CategoryEdge>
  pageInfo: PageInfo
}

export type Profile_CategoryDeleteResponse = {
  __typename?: 'profile_categoryDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Profile_Category>
}

export type Profile_CategoryEdge = {
  __typename?: 'profile_categoryEdge'
  cursor: Scalars['String']['output']
  node: Profile_Category
}

export type Profile_CategoryFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Profile_CategoryFilter>>
  description?: InputMaybe<StringFilter>
  high_result?: InputMaybe<StringFilter>
  id?: InputMaybe<IntFilter>
  low_result?: InputMaybe<StringFilter>
  name?: InputMaybe<StringFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Profile_CategoryFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Profile_CategoryFilter>>
}

export type Profile_CategoryInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>
  high_result?: InputMaybe<Scalars['String']['input']>
  low_result?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type Profile_CategoryInsertResponse = {
  __typename?: 'profile_categoryInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Profile_Category>
}

export type Profile_CategoryOrderBy = {
  description?: InputMaybe<OrderByDirection>
  high_result?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  low_result?: InputMaybe<OrderByDirection>
  name?: InputMaybe<OrderByDirection>
}

export type Profile_CategoryUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>
  high_result?: InputMaybe<Scalars['String']['input']>
  low_result?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type Profile_CategoryUpdateResponse = {
  __typename?: 'profile_categoryUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Profile_Category>
}

export type Profile_Detail = Node & {
  __typename?: 'profile_detail'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  name?: Maybe<Scalars['String']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  profile_category?: Maybe<Profile_Category>
  profile_category_id?: Maybe<Scalars['Int']['output']>
  user_profile_detailCollection?: Maybe<User_Profile_DetailConnection>
}

export type Profile_DetailUser_Profile_DetailCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_Profile_DetailFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_Profile_DetailOrderBy>>
}

export type Profile_DetailConnection = {
  __typename?: 'profile_detailConnection'
  edges: Array<Profile_DetailEdge>
  pageInfo: PageInfo
}

export type Profile_DetailDeleteResponse = {
  __typename?: 'profile_detailDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Profile_Detail>
}

export type Profile_DetailEdge = {
  __typename?: 'profile_detailEdge'
  cursor: Scalars['String']['output']
  node: Profile_Detail
}

export type Profile_DetailFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Profile_DetailFilter>>
  description?: InputMaybe<StringFilter>
  id?: InputMaybe<IntFilter>
  name?: InputMaybe<StringFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Profile_DetailFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Profile_DetailFilter>>
  profile_category_id?: InputMaybe<IntFilter>
}

export type Profile_DetailInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  profile_category_id?: InputMaybe<Scalars['Int']['input']>
}

export type Profile_DetailInsertResponse = {
  __typename?: 'profile_detailInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Profile_Detail>
}

export type Profile_DetailOrderBy = {
  description?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  name?: InputMaybe<OrderByDirection>
  profile_category_id?: InputMaybe<OrderByDirection>
}

export type Profile_DetailUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  profile_category_id?: InputMaybe<Scalars['Int']['input']>
}

export type Profile_DetailUpdateResponse = {
  __typename?: 'profile_detailUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Profile_Detail>
}

export type Psych_Event = Node & {
  __typename?: 'psych_event'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  name?: Maybe<Scalars['String']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  user_psych_eventCollection?: Maybe<User_Psych_EventConnection>
}

export type Psych_EventUser_Psych_EventCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_Psych_EventFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_Psych_EventOrderBy>>
}

export type Psych_EventConnection = {
  __typename?: 'psych_eventConnection'
  edges: Array<Psych_EventEdge>
  pageInfo: PageInfo
}

export type Psych_EventDeleteResponse = {
  __typename?: 'psych_eventDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Psych_Event>
}

export type Psych_EventEdge = {
  __typename?: 'psych_eventEdge'
  cursor: Scalars['String']['output']
  node: Psych_Event
}

export type Psych_EventFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Psych_EventFilter>>
  description?: InputMaybe<StringFilter>
  id?: InputMaybe<IntFilter>
  name?: InputMaybe<StringFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Psych_EventFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Psych_EventFilter>>
}

export type Psych_EventInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type Psych_EventInsertResponse = {
  __typename?: 'psych_eventInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Psych_Event>
}

export type Psych_EventOrderBy = {
  description?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  name?: InputMaybe<OrderByDirection>
}

export type Psych_EventUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type Psych_EventUpdateResponse = {
  __typename?: 'psych_eventUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Psych_Event>
}

export type Research = Node & {
  __typename?: 'research'
  bot_agent: Bot_Agent
  bot_agent_id: Scalars['Int']['output']
  created_at: Scalars['Datetime']['output']
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  research_reportCollection?: Maybe<Research_ReportConnection>
}

export type ResearchResearch_ReportCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Research_ReportFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Research_ReportOrderBy>>
}

export type ResearchConnection = {
  __typename?: 'researchConnection'
  edges: Array<ResearchEdge>
  pageInfo: PageInfo
}

export type ResearchDeleteResponse = {
  __typename?: 'researchDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Research>
}

export type ResearchEdge = {
  __typename?: 'researchEdge'
  cursor: Scalars['String']['output']
  node: Research
}

export type ResearchFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ResearchFilter>>
  bot_agent_id?: InputMaybe<IntFilter>
  created_at?: InputMaybe<DatetimeFilter>
  id?: InputMaybe<IntFilter>
  name?: InputMaybe<StringFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<ResearchFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ResearchFilter>>
}

export type ResearchInsertInput = {
  bot_agent_id?: InputMaybe<Scalars['Int']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type ResearchInsertResponse = {
  __typename?: 'researchInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Research>
}

export type ResearchOrderBy = {
  bot_agent_id?: InputMaybe<OrderByDirection>
  created_at?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  name?: InputMaybe<OrderByDirection>
}

export type ResearchUpdateInput = {
  bot_agent_id?: InputMaybe<Scalars['Int']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type ResearchUpdateResponse = {
  __typename?: 'researchUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Research>
}

export type Research_Report = Node & {
  __typename?: 'research_report'
  changes_on_report?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['Datetime']['output']>
  id: Scalars['Int']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  research: Research
  research_id: Scalars['Int']['output']
  summary_report?: Maybe<Scalars['String']['output']>
  text: Scalars['String']['output']
}

export type Research_ReportConnection = {
  __typename?: 'research_reportConnection'
  edges: Array<Research_ReportEdge>
  pageInfo: PageInfo
}

export type Research_ReportDeleteResponse = {
  __typename?: 'research_reportDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Research_Report>
}

export type Research_ReportEdge = {
  __typename?: 'research_reportEdge'
  cursor: Scalars['String']['output']
  node: Research_Report
}

export type Research_ReportFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Research_ReportFilter>>
  changes_on_report?: InputMaybe<StringFilter>
  created_at?: InputMaybe<DatetimeFilter>
  id?: InputMaybe<IntFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Research_ReportFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Research_ReportFilter>>
  research_id?: InputMaybe<IntFilter>
  summary_report?: InputMaybe<StringFilter>
  text?: InputMaybe<StringFilter>
}

export type Research_ReportInsertInput = {
  changes_on_report?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  research_id?: InputMaybe<Scalars['Int']['input']>
  summary_report?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type Research_ReportInsertResponse = {
  __typename?: 'research_reportInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Research_Report>
}

export type Research_ReportOrderBy = {
  changes_on_report?: InputMaybe<OrderByDirection>
  created_at?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  research_id?: InputMaybe<OrderByDirection>
  summary_report?: InputMaybe<OrderByDirection>
  text?: InputMaybe<OrderByDirection>
}

export type Research_ReportUpdateInput = {
  changes_on_report?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  research_id?: InputMaybe<Scalars['Int']['input']>
  summary_report?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type Research_ReportUpdateResponse = {
  __typename?: 'research_reportUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Research_Report>
}

export type Scrape_Target = Node & {
  __typename?: 'scrape_target'
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  reference: Scalars['String']['output']
  scrape_tweetCollection?: Maybe<Scrape_TweetConnection>
  scrape_videoCollection?: Maybe<Scrape_VideoConnection>
  scrape_webCollection?: Maybe<Scrape_WebConnection>
  status: Scalars['String']['output']
  type: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type Scrape_TargetScrape_TweetCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Scrape_TweetFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Scrape_TweetOrderBy>>
}

export type Scrape_TargetScrape_VideoCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Scrape_VideoFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Scrape_VideoOrderBy>>
}

export type Scrape_TargetScrape_WebCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Scrape_WebFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Scrape_WebOrderBy>>
}

export type Scrape_TargetConnection = {
  __typename?: 'scrape_targetConnection'
  edges: Array<Scrape_TargetEdge>
  pageInfo: PageInfo
}

export type Scrape_TargetDeleteResponse = {
  __typename?: 'scrape_targetDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Scrape_Target>
}

export type Scrape_TargetEdge = {
  __typename?: 'scrape_targetEdge'
  cursor: Scalars['String']['output']
  node: Scrape_Target
}

export type Scrape_TargetFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Scrape_TargetFilter>>
  id?: InputMaybe<IntFilter>
  name?: InputMaybe<StringFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Scrape_TargetFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Scrape_TargetFilter>>
  reference?: InputMaybe<StringFilter>
  status?: InputMaybe<StringFilter>
  type?: InputMaybe<StringFilter>
  url?: InputMaybe<StringFilter>
}

export type Scrape_TargetInsertInput = {
  name?: InputMaybe<Scalars['String']['input']>
  reference?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type Scrape_TargetInsertResponse = {
  __typename?: 'scrape_targetInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Scrape_Target>
}

export type Scrape_TargetOrderBy = {
  id?: InputMaybe<OrderByDirection>
  name?: InputMaybe<OrderByDirection>
  reference?: InputMaybe<OrderByDirection>
  status?: InputMaybe<OrderByDirection>
  type?: InputMaybe<OrderByDirection>
  url?: InputMaybe<OrderByDirection>
}

export type Scrape_TargetUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>
  reference?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type Scrape_TargetUpdateResponse = {
  __typename?: 'scrape_targetUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Scrape_Target>
}

export type Scrape_Tweet = Node & {
  __typename?: 'scrape_tweet'
  analysis?: Maybe<Scalars['String']['output']>
  comments?: Maybe<Scalars['String']['output']>
  created_at: Scalars['Datetime']['output']
  id: Scalars['Int']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  scrape_target?: Maybe<Scrape_Target>
  scrape_target_id?: Maybe<Scalars['Int']['output']>
  status: Scalars['String']['output']
  text: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type Scrape_TweetConnection = {
  __typename?: 'scrape_tweetConnection'
  edges: Array<Scrape_TweetEdge>
  pageInfo: PageInfo
}

export type Scrape_TweetDeleteResponse = {
  __typename?: 'scrape_tweetDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Scrape_Tweet>
}

export type Scrape_TweetEdge = {
  __typename?: 'scrape_tweetEdge'
  cursor: Scalars['String']['output']
  node: Scrape_Tweet
}

export type Scrape_TweetFilter = {
  analysis?: InputMaybe<StringFilter>
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Scrape_TweetFilter>>
  comments?: InputMaybe<StringFilter>
  created_at?: InputMaybe<DatetimeFilter>
  id?: InputMaybe<IntFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Scrape_TweetFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Scrape_TweetFilter>>
  scrape_target_id?: InputMaybe<IntFilter>
  status?: InputMaybe<StringFilter>
  text?: InputMaybe<StringFilter>
  url?: InputMaybe<StringFilter>
}

export type Scrape_TweetInsertInput = {
  analysis?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  scrape_target_id?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type Scrape_TweetInsertResponse = {
  __typename?: 'scrape_tweetInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Scrape_Tweet>
}

export type Scrape_TweetOrderBy = {
  analysis?: InputMaybe<OrderByDirection>
  comments?: InputMaybe<OrderByDirection>
  created_at?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  scrape_target_id?: InputMaybe<OrderByDirection>
  status?: InputMaybe<OrderByDirection>
  text?: InputMaybe<OrderByDirection>
  url?: InputMaybe<OrderByDirection>
}

export type Scrape_TweetUpdateInput = {
  analysis?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  scrape_target_id?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type Scrape_TweetUpdateResponse = {
  __typename?: 'scrape_tweetUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Scrape_Tweet>
}

export type Scrape_Video = Node & {
  __typename?: 'scrape_video'
  analysis?: Maybe<Scalars['String']['output']>
  created_at: Scalars['Datetime']['output']
  id: Scalars['Int']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  scrape_target?: Maybe<Scrape_Target>
  scrape_target_id?: Maybe<Scalars['Int']['output']>
  status: Scalars['String']['output']
  text?: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
}

export type Scrape_VideoConnection = {
  __typename?: 'scrape_videoConnection'
  edges: Array<Scrape_VideoEdge>
  pageInfo: PageInfo
}

export type Scrape_VideoDeleteResponse = {
  __typename?: 'scrape_videoDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Scrape_Video>
}

export type Scrape_VideoEdge = {
  __typename?: 'scrape_videoEdge'
  cursor: Scalars['String']['output']
  node: Scrape_Video
}

export type Scrape_VideoFilter = {
  analysis?: InputMaybe<StringFilter>
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Scrape_VideoFilter>>
  created_at?: InputMaybe<DatetimeFilter>
  id?: InputMaybe<IntFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Scrape_VideoFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Scrape_VideoFilter>>
  scrape_target_id?: InputMaybe<IntFilter>
  status?: InputMaybe<StringFilter>
  text?: InputMaybe<StringFilter>
  url?: InputMaybe<StringFilter>
}

export type Scrape_VideoInsertInput = {
  analysis?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  scrape_target_id?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type Scrape_VideoInsertResponse = {
  __typename?: 'scrape_videoInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Scrape_Video>
}

export type Scrape_VideoOrderBy = {
  analysis?: InputMaybe<OrderByDirection>
  created_at?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  scrape_target_id?: InputMaybe<OrderByDirection>
  status?: InputMaybe<OrderByDirection>
  text?: InputMaybe<OrderByDirection>
  url?: InputMaybe<OrderByDirection>
}

export type Scrape_VideoUpdateInput = {
  analysis?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  scrape_target_id?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type Scrape_VideoUpdateResponse = {
  __typename?: 'scrape_videoUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Scrape_Video>
}

export type Scrape_Web = Node & {
  __typename?: 'scrape_web'
  analysis?: Maybe<Scalars['String']['output']>
  created_at: Scalars['Datetime']['output']
  id: Scalars['Int']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  scrape_target?: Maybe<Scrape_Target>
  scrape_target_id?: Maybe<Scalars['Int']['output']>
  status: Scalars['String']['output']
  text: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type Scrape_WebConnection = {
  __typename?: 'scrape_webConnection'
  edges: Array<Scrape_WebEdge>
  pageInfo: PageInfo
}

export type Scrape_WebDeleteResponse = {
  __typename?: 'scrape_webDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Scrape_Web>
}

export type Scrape_WebEdge = {
  __typename?: 'scrape_webEdge'
  cursor: Scalars['String']['output']
  node: Scrape_Web
}

export type Scrape_WebFilter = {
  analysis?: InputMaybe<StringFilter>
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Scrape_WebFilter>>
  created_at?: InputMaybe<DatetimeFilter>
  id?: InputMaybe<IntFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Scrape_WebFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Scrape_WebFilter>>
  scrape_target_id?: InputMaybe<IntFilter>
  status?: InputMaybe<StringFilter>
  text?: InputMaybe<StringFilter>
  url?: InputMaybe<StringFilter>
}

export type Scrape_WebInsertInput = {
  analysis?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  scrape_target_id?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type Scrape_WebInsertResponse = {
  __typename?: 'scrape_webInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Scrape_Web>
}

export type Scrape_WebOrderBy = {
  analysis?: InputMaybe<OrderByDirection>
  created_at?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  scrape_target_id?: InputMaybe<OrderByDirection>
  status?: InputMaybe<OrderByDirection>
  text?: InputMaybe<OrderByDirection>
  url?: InputMaybe<OrderByDirection>
}

export type Scrape_WebUpdateInput = {
  analysis?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  scrape_target_id?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type Scrape_WebUpdateResponse = {
  __typename?: 'scrape_webUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Scrape_Web>
}

export type Settings = Node & {
  __typename?: 'settings'
  api_call_counters?: Maybe<Scalars['JSON']['output']>
  api_rate_limits?: Maybe<Scalars['JSON']['output']>
  ingestion_chunk_size?: Maybe<Scalars['Int']['output']>
  is_singleton: Scalars['Boolean']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  set_test_alert: Scalars['Boolean']['output']
}

export type SettingsConnection = {
  __typename?: 'settingsConnection'
  edges: Array<SettingsEdge>
  pageInfo: PageInfo
}

export type SettingsDeleteResponse = {
  __typename?: 'settingsDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Settings>
}

export type SettingsEdge = {
  __typename?: 'settingsEdge'
  cursor: Scalars['String']['output']
  node: Settings
}

export type SettingsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<SettingsFilter>>
  ingestion_chunk_size?: InputMaybe<IntFilter>
  is_singleton?: InputMaybe<BooleanFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<SettingsFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<SettingsFilter>>
  set_test_alert?: InputMaybe<BooleanFilter>
}

export type SettingsInsertInput = {
  api_call_counters?: InputMaybe<Scalars['JSON']['input']>
  api_rate_limits?: InputMaybe<Scalars['JSON']['input']>
  ingestion_chunk_size?: InputMaybe<Scalars['Int']['input']>
  is_singleton?: InputMaybe<Scalars['Boolean']['input']>
  set_test_alert?: InputMaybe<Scalars['Boolean']['input']>
}

export type SettingsInsertResponse = {
  __typename?: 'settingsInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Settings>
}

export type SettingsOrderBy = {
  ingestion_chunk_size?: InputMaybe<OrderByDirection>
  is_singleton?: InputMaybe<OrderByDirection>
  set_test_alert?: InputMaybe<OrderByDirection>
}

export type SettingsUpdateInput = {
  api_call_counters?: InputMaybe<Scalars['JSON']['input']>
  api_rate_limits?: InputMaybe<Scalars['JSON']['input']>
  ingestion_chunk_size?: InputMaybe<Scalars['Int']['input']>
  is_singleton?: InputMaybe<Scalars['Boolean']['input']>
  set_test_alert?: InputMaybe<Scalars['Boolean']['input']>
}

export type SettingsUpdateResponse = {
  __typename?: 'settingsUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Settings>
}

export type Slack_Message = Node & {
  __typename?: 'slack_message'
  candle?: Maybe<Candle>
  candle_id_final?: Maybe<Scalars['Int']['output']>
  candle_id_initial?: Maybe<Scalars['Int']['output']>
  created_at?: Maybe<Scalars['Datetime']['output']>
  data?: Maybe<Scalars['JSON']['output']>
  id: Scalars['BigInt']['output']
  is_canceled?: Maybe<Scalars['Boolean']['output']>
  market_id?: Maybe<Scalars['Int']['output']>
  message?: Maybe<Scalars['String']['output']>
  message_ts?: Maybe<Scalars['BigFloat']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  slack_message_userCollection?: Maybe<Slack_Message_UserConnection>
  timeframe_id?: Maybe<Scalars['Int']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type Slack_MessageSlack_Message_UserCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Slack_Message_UserFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Slack_Message_UserOrderBy>>
}

export type Slack_MessageConnection = {
  __typename?: 'slack_messageConnection'
  edges: Array<Slack_MessageEdge>
  pageInfo: PageInfo
}

export type Slack_MessageDeleteResponse = {
  __typename?: 'slack_messageDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Slack_Message>
}

export type Slack_MessageEdge = {
  __typename?: 'slack_messageEdge'
  cursor: Scalars['String']['output']
  node: Slack_Message
}

export type Slack_MessageFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Slack_MessageFilter>>
  candle_id_final?: InputMaybe<IntFilter>
  candle_id_initial?: InputMaybe<IntFilter>
  created_at?: InputMaybe<DatetimeFilter>
  id?: InputMaybe<BigIntFilter>
  is_canceled?: InputMaybe<BooleanFilter>
  market_id?: InputMaybe<IntFilter>
  message?: InputMaybe<StringFilter>
  message_ts?: InputMaybe<BigFloatFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Slack_MessageFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Slack_MessageFilter>>
  timeframe_id?: InputMaybe<IntFilter>
  type?: InputMaybe<StringFilter>
}

export type Slack_MessageInsertInput = {
  candle_id_final?: InputMaybe<Scalars['Int']['input']>
  candle_id_initial?: InputMaybe<Scalars['Int']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  is_canceled?: InputMaybe<Scalars['Boolean']['input']>
  market_id?: InputMaybe<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  message_ts?: InputMaybe<Scalars['BigFloat']['input']>
  timeframe_id?: InputMaybe<Scalars['Int']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type Slack_MessageInsertResponse = {
  __typename?: 'slack_messageInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Slack_Message>
}

export type Slack_MessageOrderBy = {
  candle_id_final?: InputMaybe<OrderByDirection>
  candle_id_initial?: InputMaybe<OrderByDirection>
  created_at?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  is_canceled?: InputMaybe<OrderByDirection>
  market_id?: InputMaybe<OrderByDirection>
  message?: InputMaybe<OrderByDirection>
  message_ts?: InputMaybe<OrderByDirection>
  timeframe_id?: InputMaybe<OrderByDirection>
  type?: InputMaybe<OrderByDirection>
}

export type Slack_MessageUpdateInput = {
  candle_id_final?: InputMaybe<Scalars['Int']['input']>
  candle_id_initial?: InputMaybe<Scalars['Int']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  is_canceled?: InputMaybe<Scalars['Boolean']['input']>
  market_id?: InputMaybe<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  message_ts?: InputMaybe<Scalars['BigFloat']['input']>
  timeframe_id?: InputMaybe<Scalars['Int']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type Slack_MessageUpdateResponse = {
  __typename?: 'slack_messageUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Slack_Message>
}

export type Slack_Message_User = Node & {
  __typename?: 'slack_message_user'
  created_at: Scalars['Datetime']['output']
  id: Scalars['Int']['output']
  message_at?: Maybe<Scalars['Datetime']['output']>
  message_ts?: Maybe<Scalars['BigFloat']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  slack_message: Slack_Message
  slack_message_id: Scalars['Int']['output']
  sms_sent: Scalars['Boolean']['output']
  user: User
  user_id: Scalars['Int']['output']
}

export type Slack_Message_UserConnection = {
  __typename?: 'slack_message_userConnection'
  edges: Array<Slack_Message_UserEdge>
  pageInfo: PageInfo
}

export type Slack_Message_UserDeleteResponse = {
  __typename?: 'slack_message_userDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Slack_Message_User>
}

export type Slack_Message_UserEdge = {
  __typename?: 'slack_message_userEdge'
  cursor: Scalars['String']['output']
  node: Slack_Message_User
}

export type Slack_Message_UserFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Slack_Message_UserFilter>>
  created_at?: InputMaybe<DatetimeFilter>
  id?: InputMaybe<IntFilter>
  message_at?: InputMaybe<DatetimeFilter>
  message_ts?: InputMaybe<BigFloatFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Slack_Message_UserFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Slack_Message_UserFilter>>
  slack_message_id?: InputMaybe<IntFilter>
  sms_sent?: InputMaybe<BooleanFilter>
  user_id?: InputMaybe<IntFilter>
}

export type Slack_Message_UserInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  message_at?: InputMaybe<Scalars['Datetime']['input']>
  message_ts?: InputMaybe<Scalars['BigFloat']['input']>
  slack_message_id?: InputMaybe<Scalars['Int']['input']>
  sms_sent?: InputMaybe<Scalars['Boolean']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
}

export type Slack_Message_UserInsertResponse = {
  __typename?: 'slack_message_userInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Slack_Message_User>
}

export type Slack_Message_UserOrderBy = {
  created_at?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  message_at?: InputMaybe<OrderByDirection>
  message_ts?: InputMaybe<OrderByDirection>
  slack_message_id?: InputMaybe<OrderByDirection>
  sms_sent?: InputMaybe<OrderByDirection>
  user_id?: InputMaybe<OrderByDirection>
}

export type Slack_Message_UserUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  message_at?: InputMaybe<Scalars['Datetime']['input']>
  message_ts?: InputMaybe<Scalars['BigFloat']['input']>
  slack_message_id?: InputMaybe<Scalars['Int']['input']>
  sms_sent?: InputMaybe<Scalars['Boolean']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
}

export type Slack_Message_UserUpdateResponse = {
  __typename?: 'slack_message_userUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Slack_Message_User>
}

export type Strategy = Node & {
  __typename?: 'strategy'
  created_at?: Maybe<Scalars['Datetime']['output']>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  status?: Maybe<Scalars['String']['output']>
  strategy_performanceCollection?: Maybe<Strategy_PerformanceConnection>
  type?: Maybe<Scalars['String']['output']>
}

export type StrategyStrategy_PerformanceCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Strategy_PerformanceFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Strategy_PerformanceOrderBy>>
}

export type StrategyConnection = {
  __typename?: 'strategyConnection'
  edges: Array<StrategyEdge>
  pageInfo: PageInfo
}

export type StrategyDeleteResponse = {
  __typename?: 'strategyDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Strategy>
}

export type StrategyEdge = {
  __typename?: 'strategyEdge'
  cursor: Scalars['String']['output']
  node: Strategy
}

export type StrategyFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<StrategyFilter>>
  created_at?: InputMaybe<DatetimeFilter>
  description?: InputMaybe<StringFilter>
  id?: InputMaybe<IntFilter>
  name?: InputMaybe<StringFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<StrategyFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<StrategyFilter>>
  status?: InputMaybe<StringFilter>
  type?: InputMaybe<StringFilter>
}

export type StrategyInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type StrategyInsertResponse = {
  __typename?: 'strategyInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Strategy>
}

export type StrategyOrderBy = {
  created_at?: InputMaybe<OrderByDirection>
  description?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  name?: InputMaybe<OrderByDirection>
  status?: InputMaybe<OrderByDirection>
  type?: InputMaybe<OrderByDirection>
}

export type StrategyUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type StrategyUpdateResponse = {
  __typename?: 'strategyUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Strategy>
}

export type Strategy_Performance = Node & {
  __typename?: 'strategy_performance'
  data?: Maybe<Scalars['JSON']['output']>
  id: Scalars['Int']['output']
  market: Market
  market_id: Scalars['Int']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  parameters?: Maybe<Scalars['JSON']['output']>
  strategy: Strategy
  strategy_id: Scalars['Int']['output']
  timeframe: Timeframe
  timeframe_id: Scalars['Int']['output']
  version: Scalars['Int']['output']
}

export type Strategy_PerformanceConnection = {
  __typename?: 'strategy_performanceConnection'
  edges: Array<Strategy_PerformanceEdge>
  pageInfo: PageInfo
}

export type Strategy_PerformanceDeleteResponse = {
  __typename?: 'strategy_performanceDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Strategy_Performance>
}

export type Strategy_PerformanceEdge = {
  __typename?: 'strategy_performanceEdge'
  cursor: Scalars['String']['output']
  node: Strategy_Performance
}

export type Strategy_PerformanceFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Strategy_PerformanceFilter>>
  id?: InputMaybe<IntFilter>
  market_id?: InputMaybe<IntFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Strategy_PerformanceFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Strategy_PerformanceFilter>>
  strategy_id?: InputMaybe<IntFilter>
  timeframe_id?: InputMaybe<IntFilter>
  version?: InputMaybe<IntFilter>
}

export type Strategy_PerformanceInsertInput = {
  data?: InputMaybe<Scalars['JSON']['input']>
  market_id?: InputMaybe<Scalars['Int']['input']>
  parameters?: InputMaybe<Scalars['JSON']['input']>
  strategy_id?: InputMaybe<Scalars['Int']['input']>
  timeframe_id?: InputMaybe<Scalars['Int']['input']>
  version?: InputMaybe<Scalars['Int']['input']>
}

export type Strategy_PerformanceInsertResponse = {
  __typename?: 'strategy_performanceInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Strategy_Performance>
}

export type Strategy_PerformanceOrderBy = {
  id?: InputMaybe<OrderByDirection>
  market_id?: InputMaybe<OrderByDirection>
  strategy_id?: InputMaybe<OrderByDirection>
  timeframe_id?: InputMaybe<OrderByDirection>
  version?: InputMaybe<OrderByDirection>
}

export type Strategy_PerformanceUpdateInput = {
  data?: InputMaybe<Scalars['JSON']['input']>
  market_id?: InputMaybe<Scalars['Int']['input']>
  parameters?: InputMaybe<Scalars['JSON']['input']>
  strategy_id?: InputMaybe<Scalars['Int']['input']>
  timeframe_id?: InputMaybe<Scalars['Int']['input']>
  version?: InputMaybe<Scalars['Int']['input']>
}

export type Strategy_PerformanceUpdateResponse = {
  __typename?: 'strategy_performanceUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Strategy_Performance>
}

export type Timeframe = Node & {
  __typename?: 'timeframe'
  candleCollection?: Maybe<CandleConnection>
  id: Scalars['Int']['output']
  is_watched?: Maybe<Scalars['Boolean']['output']>
  minutes?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  positionCollection?: Maybe<PositionConnection>
  strategy_performanceCollection?: Maybe<Strategy_PerformanceConnection>
  tv_id?: Maybe<Scalars['String']['output']>
  user_watchingCollection?: Maybe<User_WatchingConnection>
}

export type TimeframeCandleCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<CandleFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<CandleOrderBy>>
}

export type TimeframePositionCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<PositionFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<PositionOrderBy>>
}

export type TimeframeStrategy_PerformanceCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Strategy_PerformanceFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Strategy_PerformanceOrderBy>>
}

export type TimeframeUser_WatchingCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_WatchingFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_WatchingOrderBy>>
}

export type TimeframeConnection = {
  __typename?: 'timeframeConnection'
  edges: Array<TimeframeEdge>
  pageInfo: PageInfo
}

export type TimeframeDeleteResponse = {
  __typename?: 'timeframeDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Timeframe>
}

export type TimeframeEdge = {
  __typename?: 'timeframeEdge'
  cursor: Scalars['String']['output']
  node: Timeframe
}

export type TimeframeFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<TimeframeFilter>>
  id?: InputMaybe<IntFilter>
  is_watched?: InputMaybe<BooleanFilter>
  minutes?: InputMaybe<IntFilter>
  name?: InputMaybe<StringFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<TimeframeFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<TimeframeFilter>>
  tv_id?: InputMaybe<StringFilter>
}

export type TimeframeInsertInput = {
  is_watched?: InputMaybe<Scalars['Boolean']['input']>
  minutes?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  tv_id?: InputMaybe<Scalars['String']['input']>
}

export type TimeframeInsertResponse = {
  __typename?: 'timeframeInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Timeframe>
}

export type TimeframeOrderBy = {
  id?: InputMaybe<OrderByDirection>
  is_watched?: InputMaybe<OrderByDirection>
  minutes?: InputMaybe<OrderByDirection>
  name?: InputMaybe<OrderByDirection>
  tv_id?: InputMaybe<OrderByDirection>
}

export type TimeframeUpdateInput = {
  is_watched?: InputMaybe<Scalars['Boolean']['input']>
  minutes?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  tv_id?: InputMaybe<Scalars['String']['input']>
}

export type TimeframeUpdateResponse = {
  __typename?: 'timeframeUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Timeframe>
}

export type Tv_Alert = Node & {
  __typename?: 'tv_alert'
  candleCollection?: Maybe<CandleConnection>
  close?: Maybe<Scalars['BigFloat']['output']>
  created_at?: Maybe<Scalars['Datetime']['output']>
  data?: Maybe<Scalars['JSON']['output']>
  debug?: Maybe<Scalars['JSON']['output']>
  id: Scalars['Int']['output']
  ingested_at?: Maybe<Scalars['Datetime']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  raw_payload?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  ticker?: Maybe<Scalars['String']['output']>
  tv_timestamp?: Maybe<Scalars['BigFloat']['output']>
}

export type Tv_AlertCandleCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<CandleFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<CandleOrderBy>>
}

export type Tv_AlertConnection = {
  __typename?: 'tv_alertConnection'
  edges: Array<Tv_AlertEdge>
  pageInfo: PageInfo
}

export type Tv_AlertDeleteResponse = {
  __typename?: 'tv_alertDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Tv_Alert>
}

export type Tv_AlertEdge = {
  __typename?: 'tv_alertEdge'
  cursor: Scalars['String']['output']
  node: Tv_Alert
}

export type Tv_AlertFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Tv_AlertFilter>>
  close?: InputMaybe<BigFloatFilter>
  created_at?: InputMaybe<DatetimeFilter>
  id?: InputMaybe<IntFilter>
  ingested_at?: InputMaybe<DatetimeFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<Tv_AlertFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Tv_AlertFilter>>
  raw_payload?: InputMaybe<StringFilter>
  status?: InputMaybe<StringFilter>
  ticker?: InputMaybe<StringFilter>
  tv_timestamp?: InputMaybe<BigFloatFilter>
}

export type Tv_AlertInsertInput = {
  close?: InputMaybe<Scalars['BigFloat']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  debug?: InputMaybe<Scalars['JSON']['input']>
  ingested_at?: InputMaybe<Scalars['Datetime']['input']>
  raw_payload?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  ticker?: InputMaybe<Scalars['String']['input']>
  tv_timestamp?: InputMaybe<Scalars['BigFloat']['input']>
}

export type Tv_AlertInsertResponse = {
  __typename?: 'tv_alertInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Tv_Alert>
}

export type Tv_AlertOrderBy = {
  close?: InputMaybe<OrderByDirection>
  created_at?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  ingested_at?: InputMaybe<OrderByDirection>
  raw_payload?: InputMaybe<OrderByDirection>
  status?: InputMaybe<OrderByDirection>
  ticker?: InputMaybe<OrderByDirection>
  tv_timestamp?: InputMaybe<OrderByDirection>
}

export type Tv_AlertUpdateInput = {
  close?: InputMaybe<Scalars['BigFloat']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  debug?: InputMaybe<Scalars['JSON']['input']>
  ingested_at?: InputMaybe<Scalars['Datetime']['input']>
  raw_payload?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  ticker?: InputMaybe<Scalars['String']['input']>
  tv_timestamp?: InputMaybe<Scalars['BigFloat']['input']>
}

export type Tv_AlertUpdateResponse = {
  __typename?: 'tv_alertUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<Tv_Alert>
}

export type User = Node & {
  __typename?: 'user'
  assets?: Maybe<Scalars['JSON']['output']>
  balance_snapshotCollection?: Maybe<Balance_SnapshotConnection>
  created_at?: Maybe<Scalars['Datetime']['output']>
  email?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  live_pass?: Maybe<Scalars['String']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  positionCollection?: Maybe<PositionConnection>
  position_usd_amount?: Maybe<Scalars['BigFloat']['output']>
  profile_analysis?: Maybe<Scalars['String']['output']>
  slack_message_userCollection?: Maybe<Slack_Message_UserConnection>
  slack_user_id?: Maybe<Scalars['String']['output']>
  slack_user_name?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  stop_loss_percent?: Maybe<Scalars['BigFloat']['output']>
  take_profit_percent?: Maybe<Scalars['BigFloat']['output']>
  total_amount?: Maybe<Scalars['BigFloat']['output']>
  total_amount_live?: Maybe<Scalars['BigFloat']['output']>
  usd_amount?: Maybe<Scalars['Int']['output']>
  user_bot_agentCollection?: Maybe<User_Bot_AgentConnection>
  user_profile_categoryCollection?: Maybe<User_Profile_CategoryConnection>
  user_psych_eventCollection?: Maybe<User_Psych_EventConnection>
  user_watchingCollection?: Maybe<User_WatchingConnection>
}

export type UserBalance_SnapshotCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Balance_SnapshotFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Balance_SnapshotOrderBy>>
}

export type UserPositionCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<PositionFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<PositionOrderBy>>
}

export type UserSlack_Message_UserCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<Slack_Message_UserFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<Slack_Message_UserOrderBy>>
}

export type UserUser_Bot_AgentCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_Bot_AgentFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_Bot_AgentOrderBy>>
}

export type UserUser_Profile_CategoryCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_Profile_CategoryFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_Profile_CategoryOrderBy>>
}

export type UserUser_Psych_EventCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_Psych_EventFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_Psych_EventOrderBy>>
}

export type UserUser_WatchingCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_WatchingFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_WatchingOrderBy>>
}

export type UserConnection = {
  __typename?: 'userConnection'
  edges: Array<UserEdge>
  pageInfo: PageInfo
}

export type UserDeleteResponse = {
  __typename?: 'userDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User>
}

export type UserEdge = {
  __typename?: 'userEdge'
  cursor: Scalars['String']['output']
  node: User
}

export type UserFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<UserFilter>>
  created_at?: InputMaybe<DatetimeFilter>
  email?: InputMaybe<StringFilter>
  id?: InputMaybe<IntFilter>
  live_pass?: InputMaybe<StringFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<UserFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<UserFilter>>
  position_usd_amount?: InputMaybe<BigFloatFilter>
  profile_analysis?: InputMaybe<StringFilter>
  slack_user_id?: InputMaybe<StringFilter>
  slack_user_name?: InputMaybe<StringFilter>
  status?: InputMaybe<StringFilter>
  stop_loss_percent?: InputMaybe<BigFloatFilter>
  take_profit_percent?: InputMaybe<BigFloatFilter>
  total_amount?: InputMaybe<BigFloatFilter>
  total_amount_live?: InputMaybe<BigFloatFilter>
  usd_amount?: InputMaybe<IntFilter>
}

export type UserInsertInput = {
  assets?: InputMaybe<Scalars['JSON']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  live_pass?: InputMaybe<Scalars['String']['input']>
  position_usd_amount?: InputMaybe<Scalars['BigFloat']['input']>
  profile_analysis?: InputMaybe<Scalars['String']['input']>
  slack_user_id?: InputMaybe<Scalars['String']['input']>
  slack_user_name?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  stop_loss_percent?: InputMaybe<Scalars['BigFloat']['input']>
  take_profit_percent?: InputMaybe<Scalars['BigFloat']['input']>
  total_amount?: InputMaybe<Scalars['BigFloat']['input']>
  total_amount_live?: InputMaybe<Scalars['BigFloat']['input']>
  usd_amount?: InputMaybe<Scalars['Int']['input']>
}

export type UserInsertResponse = {
  __typename?: 'userInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User>
}

export type UserOrderBy = {
  created_at?: InputMaybe<OrderByDirection>
  email?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  live_pass?: InputMaybe<OrderByDirection>
  position_usd_amount?: InputMaybe<OrderByDirection>
  profile_analysis?: InputMaybe<OrderByDirection>
  slack_user_id?: InputMaybe<OrderByDirection>
  slack_user_name?: InputMaybe<OrderByDirection>
  status?: InputMaybe<OrderByDirection>
  stop_loss_percent?: InputMaybe<OrderByDirection>
  take_profit_percent?: InputMaybe<OrderByDirection>
  total_amount?: InputMaybe<OrderByDirection>
  total_amount_live?: InputMaybe<OrderByDirection>
  usd_amount?: InputMaybe<OrderByDirection>
}

export type UserUpdateInput = {
  assets?: InputMaybe<Scalars['JSON']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  live_pass?: InputMaybe<Scalars['String']['input']>
  position_usd_amount?: InputMaybe<Scalars['BigFloat']['input']>
  profile_analysis?: InputMaybe<Scalars['String']['input']>
  slack_user_id?: InputMaybe<Scalars['String']['input']>
  slack_user_name?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  stop_loss_percent?: InputMaybe<Scalars['BigFloat']['input']>
  take_profit_percent?: InputMaybe<Scalars['BigFloat']['input']>
  total_amount?: InputMaybe<Scalars['BigFloat']['input']>
  total_amount_live?: InputMaybe<Scalars['BigFloat']['input']>
  usd_amount?: InputMaybe<Scalars['Int']['input']>
}

export type UserUpdateResponse = {
  __typename?: 'userUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User>
}

export type User_Bot_Agent = Node & {
  __typename?: 'user_bot_agent'
  bot_agent: Bot_Agent
  bot_agent_id: Scalars['Int']['output']
  buffer?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  memory?: Maybe<Scalars['String']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  updated_at?: Maybe<Scalars['Datetime']['output']>
  user: User
  user_bot_conversationCollection?: Maybe<User_Bot_ConversationConnection>
  user_id: Scalars['Int']['output']
}

export type User_Bot_AgentUser_Bot_ConversationCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<User_Bot_ConversationFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<User_Bot_ConversationOrderBy>>
}

export type User_Bot_AgentConnection = {
  __typename?: 'user_bot_agentConnection'
  edges: Array<User_Bot_AgentEdge>
  pageInfo: PageInfo
}

export type User_Bot_AgentDeleteResponse = {
  __typename?: 'user_bot_agentDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Bot_Agent>
}

export type User_Bot_AgentEdge = {
  __typename?: 'user_bot_agentEdge'
  cursor: Scalars['String']['output']
  node: User_Bot_Agent
}

export type User_Bot_AgentFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<User_Bot_AgentFilter>>
  bot_agent_id?: InputMaybe<IntFilter>
  buffer?: InputMaybe<StringFilter>
  id?: InputMaybe<IntFilter>
  memory?: InputMaybe<StringFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<User_Bot_AgentFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<User_Bot_AgentFilter>>
  updated_at?: InputMaybe<DatetimeFilter>
  user_id?: InputMaybe<IntFilter>
}

export type User_Bot_AgentInsertInput = {
  bot_agent_id?: InputMaybe<Scalars['Int']['input']>
  buffer?: InputMaybe<Scalars['String']['input']>
  memory?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['Datetime']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
}

export type User_Bot_AgentInsertResponse = {
  __typename?: 'user_bot_agentInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Bot_Agent>
}

export type User_Bot_AgentOrderBy = {
  bot_agent_id?: InputMaybe<OrderByDirection>
  buffer?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  memory?: InputMaybe<OrderByDirection>
  updated_at?: InputMaybe<OrderByDirection>
  user_id?: InputMaybe<OrderByDirection>
}

export type User_Bot_AgentUpdateInput = {
  bot_agent_id?: InputMaybe<Scalars['Int']['input']>
  buffer?: InputMaybe<Scalars['String']['input']>
  memory?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['Datetime']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
}

export type User_Bot_AgentUpdateResponse = {
  __typename?: 'user_bot_agentUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Bot_Agent>
}

export type User_Bot_Conversation = Node & {
  __typename?: 'user_bot_conversation'
  buffer?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['Datetime']['output']>
  id: Scalars['Int']['output']
  is_in_bot_memory?: Maybe<Scalars['Boolean']['output']>
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  question?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  tags?: Maybe<Scalars['String']['output']>
  thread_ts: Scalars['BigFloat']['output']
  topic?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['Datetime']['output']>
  user_bot_agent?: Maybe<User_Bot_Agent>
  user_bot_agent_id?: Maybe<Scalars['Int']['output']>
}

export type User_Bot_ConversationConnection = {
  __typename?: 'user_bot_conversationConnection'
  edges: Array<User_Bot_ConversationEdge>
  pageInfo: PageInfo
}

export type User_Bot_ConversationDeleteResponse = {
  __typename?: 'user_bot_conversationDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Bot_Conversation>
}

export type User_Bot_ConversationEdge = {
  __typename?: 'user_bot_conversationEdge'
  cursor: Scalars['String']['output']
  node: User_Bot_Conversation
}

export type User_Bot_ConversationFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<User_Bot_ConversationFilter>>
  buffer?: InputMaybe<StringFilter>
  created_at?: InputMaybe<DatetimeFilter>
  id?: InputMaybe<IntFilter>
  is_in_bot_memory?: InputMaybe<BooleanFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<User_Bot_ConversationFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<User_Bot_ConversationFilter>>
  question?: InputMaybe<StringFilter>
  summary?: InputMaybe<StringFilter>
  tags?: InputMaybe<StringFilter>
  thread_ts?: InputMaybe<BigFloatFilter>
  topic?: InputMaybe<StringFilter>
  updated_at?: InputMaybe<DatetimeFilter>
  user_bot_agent_id?: InputMaybe<IntFilter>
}

export type User_Bot_ConversationInsertInput = {
  buffer?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  is_in_bot_memory?: InputMaybe<Scalars['Boolean']['input']>
  question?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Scalars['String']['input']>
  thread_ts?: InputMaybe<Scalars['BigFloat']['input']>
  topic?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['Datetime']['input']>
  user_bot_agent_id?: InputMaybe<Scalars['Int']['input']>
}

export type User_Bot_ConversationInsertResponse = {
  __typename?: 'user_bot_conversationInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Bot_Conversation>
}

export type User_Bot_ConversationOrderBy = {
  buffer?: InputMaybe<OrderByDirection>
  created_at?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  is_in_bot_memory?: InputMaybe<OrderByDirection>
  question?: InputMaybe<OrderByDirection>
  summary?: InputMaybe<OrderByDirection>
  tags?: InputMaybe<OrderByDirection>
  thread_ts?: InputMaybe<OrderByDirection>
  topic?: InputMaybe<OrderByDirection>
  updated_at?: InputMaybe<OrderByDirection>
  user_bot_agent_id?: InputMaybe<OrderByDirection>
}

export type User_Bot_ConversationUpdateInput = {
  buffer?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  is_in_bot_memory?: InputMaybe<Scalars['Boolean']['input']>
  question?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Scalars['String']['input']>
  thread_ts?: InputMaybe<Scalars['BigFloat']['input']>
  topic?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['Datetime']['input']>
  user_bot_agent_id?: InputMaybe<Scalars['Int']['input']>
}

export type User_Bot_ConversationUpdateResponse = {
  __typename?: 'user_bot_conversationUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Bot_Conversation>
}

export type User_Profile_Category = Node & {
  __typename?: 'user_profile_category'
  created_at?: Maybe<Scalars['Datetime']['output']>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  profile_category?: Maybe<Profile_Category>
  profile_category_id?: Maybe<Scalars['Int']['output']>
  user?: Maybe<User>
  user_id?: Maybe<Scalars['Int']['output']>
  value?: Maybe<Scalars['BigFloat']['output']>
}

export type User_Profile_CategoryConnection = {
  __typename?: 'user_profile_categoryConnection'
  edges: Array<User_Profile_CategoryEdge>
  pageInfo: PageInfo
}

export type User_Profile_CategoryDeleteResponse = {
  __typename?: 'user_profile_categoryDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Profile_Category>
}

export type User_Profile_CategoryEdge = {
  __typename?: 'user_profile_categoryEdge'
  cursor: Scalars['String']['output']
  node: User_Profile_Category
}

export type User_Profile_CategoryFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<User_Profile_CategoryFilter>>
  created_at?: InputMaybe<DatetimeFilter>
  description?: InputMaybe<StringFilter>
  id?: InputMaybe<IntFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<User_Profile_CategoryFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<User_Profile_CategoryFilter>>
  profile_category_id?: InputMaybe<IntFilter>
  user_id?: InputMaybe<IntFilter>
  value?: InputMaybe<BigFloatFilter>
}

export type User_Profile_CategoryInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  profile_category_id?: InputMaybe<Scalars['Int']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
  value?: InputMaybe<Scalars['BigFloat']['input']>
}

export type User_Profile_CategoryInsertResponse = {
  __typename?: 'user_profile_categoryInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Profile_Category>
}

export type User_Profile_CategoryOrderBy = {
  created_at?: InputMaybe<OrderByDirection>
  description?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  profile_category_id?: InputMaybe<OrderByDirection>
  user_id?: InputMaybe<OrderByDirection>
  value?: InputMaybe<OrderByDirection>
}

export type User_Profile_CategoryUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  profile_category_id?: InputMaybe<Scalars['Int']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
  value?: InputMaybe<Scalars['BigFloat']['input']>
}

export type User_Profile_CategoryUpdateResponse = {
  __typename?: 'user_profile_categoryUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Profile_Category>
}

export type User_Profile_Detail = Node & {
  __typename?: 'user_profile_detail'
  created_at?: Maybe<Scalars['Datetime']['output']>
  id: Scalars['Int']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  profile_detail?: Maybe<Profile_Detail>
  profile_detail_id?: Maybe<Scalars['Int']['output']>
  user_profile_category_id?: Maybe<Scalars['Int']['output']>
  value?: Maybe<Scalars['Int']['output']>
}

export type User_Profile_DetailConnection = {
  __typename?: 'user_profile_detailConnection'
  edges: Array<User_Profile_DetailEdge>
  pageInfo: PageInfo
}

export type User_Profile_DetailDeleteResponse = {
  __typename?: 'user_profile_detailDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Profile_Detail>
}

export type User_Profile_DetailEdge = {
  __typename?: 'user_profile_detailEdge'
  cursor: Scalars['String']['output']
  node: User_Profile_Detail
}

export type User_Profile_DetailFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<User_Profile_DetailFilter>>
  created_at?: InputMaybe<DatetimeFilter>
  id?: InputMaybe<IntFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<User_Profile_DetailFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<User_Profile_DetailFilter>>
  profile_detail_id?: InputMaybe<IntFilter>
  user_profile_category_id?: InputMaybe<IntFilter>
  value?: InputMaybe<IntFilter>
}

export type User_Profile_DetailInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  profile_detail_id?: InputMaybe<Scalars['Int']['input']>
  user_profile_category_id?: InputMaybe<Scalars['Int']['input']>
  value?: InputMaybe<Scalars['Int']['input']>
}

export type User_Profile_DetailInsertResponse = {
  __typename?: 'user_profile_detailInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Profile_Detail>
}

export type User_Profile_DetailOrderBy = {
  created_at?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  profile_detail_id?: InputMaybe<OrderByDirection>
  user_profile_category_id?: InputMaybe<OrderByDirection>
  value?: InputMaybe<OrderByDirection>
}

export type User_Profile_DetailUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  profile_detail_id?: InputMaybe<Scalars['Int']['input']>
  user_profile_category_id?: InputMaybe<Scalars['Int']['input']>
  value?: InputMaybe<Scalars['Int']['input']>
}

export type User_Profile_DetailUpdateResponse = {
  __typename?: 'user_profile_detailUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Profile_Detail>
}

export type User_Psych_Event = Node & {
  __typename?: 'user_psych_event'
  analysis?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['Datetime']['output']>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  psych_event?: Maybe<Psych_Event>
  psych_event_id?: Maybe<Scalars['Int']['output']>
  solved?: Maybe<Scalars['Boolean']['output']>
  user?: Maybe<User>
  user_id?: Maybe<Scalars['Int']['output']>
}

export type User_Psych_EventConnection = {
  __typename?: 'user_psych_eventConnection'
  edges: Array<User_Psych_EventEdge>
  pageInfo: PageInfo
}

export type User_Psych_EventDeleteResponse = {
  __typename?: 'user_psych_eventDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Psych_Event>
}

export type User_Psych_EventEdge = {
  __typename?: 'user_psych_eventEdge'
  cursor: Scalars['String']['output']
  node: User_Psych_Event
}

export type User_Psych_EventFilter = {
  analysis?: InputMaybe<StringFilter>
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<User_Psych_EventFilter>>
  created_at?: InputMaybe<DatetimeFilter>
  description?: InputMaybe<StringFilter>
  id?: InputMaybe<IntFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<User_Psych_EventFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<User_Psych_EventFilter>>
  psych_event_id?: InputMaybe<IntFilter>
  solved?: InputMaybe<BooleanFilter>
  user_id?: InputMaybe<IntFilter>
}

export type User_Psych_EventInsertInput = {
  analysis?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  psych_event_id?: InputMaybe<Scalars['Int']['input']>
  solved?: InputMaybe<Scalars['Boolean']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
}

export type User_Psych_EventInsertResponse = {
  __typename?: 'user_psych_eventInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Psych_Event>
}

export type User_Psych_EventOrderBy = {
  analysis?: InputMaybe<OrderByDirection>
  created_at?: InputMaybe<OrderByDirection>
  description?: InputMaybe<OrderByDirection>
  id?: InputMaybe<OrderByDirection>
  psych_event_id?: InputMaybe<OrderByDirection>
  solved?: InputMaybe<OrderByDirection>
  user_id?: InputMaybe<OrderByDirection>
}

export type User_Psych_EventUpdateInput = {
  analysis?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['Datetime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  psych_event_id?: InputMaybe<Scalars['Int']['input']>
  solved?: InputMaybe<Scalars['Boolean']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
}

export type User_Psych_EventUpdateResponse = {
  __typename?: 'user_psych_eventUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Psych_Event>
}

export type User_Watching = Node & {
  __typename?: 'user_watching'
  id: Scalars['Int']['output']
  is_active: Scalars['Boolean']['output']
  market: Market
  market_id: Scalars['Int']['output']
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output']
  timeframe: Timeframe
  timeframe_id: Scalars['Int']['output']
  user: User
  user_id: Scalars['Int']['output']
}

export type User_WatchingConnection = {
  __typename?: 'user_watchingConnection'
  edges: Array<User_WatchingEdge>
  pageInfo: PageInfo
}

export type User_WatchingDeleteResponse = {
  __typename?: 'user_watchingDeleteResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Watching>
}

export type User_WatchingEdge = {
  __typename?: 'user_watchingEdge'
  cursor: Scalars['String']['output']
  node: User_Watching
}

export type User_WatchingFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<User_WatchingFilter>>
  id?: InputMaybe<IntFilter>
  is_active?: InputMaybe<BooleanFilter>
  market_id?: InputMaybe<IntFilter>
  nodeId?: InputMaybe<IdFilter>
  /** Negates a filter */
  not?: InputMaybe<User_WatchingFilter>
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<User_WatchingFilter>>
  timeframe_id?: InputMaybe<IntFilter>
  user_id?: InputMaybe<IntFilter>
}

export type User_WatchingInsertInput = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>
  market_id?: InputMaybe<Scalars['Int']['input']>
  timeframe_id?: InputMaybe<Scalars['Int']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
}

export type User_WatchingInsertResponse = {
  __typename?: 'user_watchingInsertResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Watching>
}

export type User_WatchingOrderBy = {
  id?: InputMaybe<OrderByDirection>
  is_active?: InputMaybe<OrderByDirection>
  market_id?: InputMaybe<OrderByDirection>
  timeframe_id?: InputMaybe<OrderByDirection>
  user_id?: InputMaybe<OrderByDirection>
}

export type User_WatchingUpdateInput = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>
  market_id?: InputMaybe<Scalars['Int']['input']>
  timeframe_id?: InputMaybe<Scalars['Int']['input']>
  user_id?: InputMaybe<Scalars['Int']['input']>
}

export type User_WatchingUpdateResponse = {
  __typename?: 'user_watchingUpdateResponse'
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output']
  /** Array of records impacted by the mutation */
  records: Array<User_Watching>
}

export type GetAllMarketsQueryVariables = Exact<{ [key: string]: never }>

export type GetAllMarketsQuery = {
  __typename?: 'Query'
  marketCollection?: {
    __typename?: 'marketConnection'
    edges: Array<{
      __typename?: 'marketEdge'
      node: {
        __typename?: 'market'
        id: number
        name?: string | null
        short_name?: string | null
        ticker: string
        price?: any | null
        type?: string | null
        created_at?: any | null
        last_update_at?: any | null
        trend_status?: string | null
        sentiment?: string | null
        sentiment_update_at?: any | null
        market_activity_score_1h?: any | null
        market_activity_score_1d?: any | null
        data?: Record<string, any> | null
        status?: string | null
      }
    }>
  } | null
}

export type GetMarketByIdQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetMarketByIdQuery = {
  __typename?: 'Query'
  marketCollection?: {
    __typename?: 'marketConnection'
    edges: Array<{
      __typename?: 'marketEdge'
      node: {
        __typename?: 'market'
        id: number
        name?: string | null
        short_name?: string | null
        ticker: string
        price?: any | null
        type?: string | null
        created_at?: any | null
        last_update_at?: any | null
        trend_status?: string | null
        sentiment?: string | null
        sentiment_update_at?: any | null
        market_activity_score_1h?: any | null
        market_activity_score_1d?: any | null
        data?: Record<string, any> | null
        status?: string | null
      }
    }>
  } | null
}

export type GetMarketByTickerQueryVariables = Exact<{
  ticker: Scalars['String']['input']
}>

export type GetMarketByTickerQuery = {
  __typename?: 'Query'
  marketCollection?: {
    __typename?: 'marketConnection'
    edges: Array<{
      __typename?: 'marketEdge'
      node: {
        __typename?: 'market'
        id: number
        name?: string | null
        short_name?: string | null
        ticker: string
        price?: any | null
        type?: string | null
        created_at?: any | null
        last_update_at?: any | null
        trend_status?: string | null
        sentiment?: string | null
        sentiment_update_at?: any | null
        market_activity_score_1h?: any | null
        market_activity_score_1d?: any | null
        data?: Record<string, any> | null
        status?: string | null
      }
    }>
  } | null
}

export type GetMarketsByStatusQueryVariables = Exact<{
  status: Scalars['String']['input']
}>

export type GetMarketsByStatusQuery = {
  __typename?: 'Query'
  marketCollection?: {
    __typename?: 'marketConnection'
    edges: Array<{
      __typename?: 'marketEdge'
      node: {
        __typename?: 'market'
        id: number
        name?: string | null
        short_name?: string | null
        ticker: string
        price?: any | null
        type?: string | null
        created_at?: any | null
        last_update_at?: any | null
        trend_status?: string | null
        sentiment?: string | null
        sentiment_update_at?: any | null
        market_activity_score_1h?: any | null
        market_activity_score_1d?: any | null
        data?: Record<string, any> | null
        status?: string | null
      }
    }>
  } | null
}

export const GetAllMarketsDocument = gql`
  query GetAllMarkets {
    marketCollection {
      edges {
        node {
          id
          name
          short_name
          ticker
          price
          type
          created_at
          last_update_at
          trend_status
          sentiment
          sentiment_update_at
          market_activity_score_1h
          market_activity_score_1d
          data
          status
        }
      }
    }
  }
`
export const GetMarketByIdDocument = gql`
  query GetMarketById($id: Int!) {
    marketCollection(filter: { id: { eq: $id } }) {
      edges {
        node {
          id
          name
          short_name
          ticker
          price
          type
          created_at
          last_update_at
          trend_status
          sentiment
          sentiment_update_at
          market_activity_score_1h
          market_activity_score_1d
          data
          status
        }
      }
    }
  }
`
export const GetMarketByTickerDocument = gql`
  query GetMarketByTicker($ticker: String!) {
    marketCollection(filter: { ticker: { eq: $ticker } }) {
      edges {
        node {
          id
          name
          short_name
          ticker
          price
          type
          created_at
          last_update_at
          trend_status
          sentiment
          sentiment_update_at
          market_activity_score_1h
          market_activity_score_1d
          data
          status
        }
      }
    }
  }
`
export const GetMarketsByStatusDocument = gql`
  query GetMarketsByStatus($status: String!) {
    marketCollection(filter: { status: { eq: $status } }) {
      edges {
        node {
          id
          name
          short_name
          ticker
          price
          type
          created_at
          last_update_at
          trend_status
          sentiment
          sentiment_update_at
          market_activity_score_1h
          market_activity_score_1d
          data
          status
        }
      }
    }
  }
`

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
  variables?: any
) => Promise<T>

const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) =>
  action()

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    GetAllMarkets(
      variables?: GetAllMarketsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<GetAllMarketsQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<GetAllMarketsQuery>({
            document: GetAllMarketsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'GetAllMarkets',
        'query',
        variables
      )
    },
    GetMarketById(
      variables: GetMarketByIdQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<GetMarketByIdQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<GetMarketByIdQuery>({
            document: GetMarketByIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'GetMarketById',
        'query',
        variables
      )
    },
    GetMarketByTicker(
      variables: GetMarketByTickerQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<GetMarketByTickerQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<GetMarketByTickerQuery>({
            document: GetMarketByTickerDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'GetMarketByTicker',
        'query',
        variables
      )
    },
    GetMarketsByStatus(
      variables: GetMarketsByStatusQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal']
    ): Promise<GetMarketsByStatusQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<GetMarketsByStatusQuery>({
            document: GetMarketsByStatusDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal
          }),
        'GetMarketsByStatus',
        'query',
        variables
      )
    }
  }
}
export type Sdk = ReturnType<typeof getSdk>
